<template>
  <div align="center">
    <v-toolbar dense class="rounded">
      <v-btn icon class="hidden-xs-only" @click="$router.push('/gametype')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>TÉRMINOS Y CONDICIONES DEPORTES</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-toolbar>

    <div class="mt-3 rounded white pa-10 text-justify">
      <div>
   <strong><p>
        TAR.LA – REGLAS OFICIALES COMPLETAS DE APUESTAS DEPORTIVAS
    </p></strong> 
</div>
<p>
    Sitio oficial: https://tar.la/
</p>
<p>
    Estas reglas aplican a todos los Jugadores y a todas las apuestas deportivas
    ofrecidas en la plataforma. En caso de conflicto con comunicaciones
    promocionales, prevalecerán estas reglas, los Términos y Condiciones y el
    registro interno del sistema.
</p>
<p>
    <strong>ÍNDICE</strong> <strong></strong>
</p>
<p>
    <strong>1.</strong> <strong>1. Introducción y alcance</strong>
</p>
<p>
    <strong>2.</strong> <strong>2. Definiciones</strong>
</p>
<p>
    <strong>3.</strong> <strong>3. Principios generales y evidencias</strong>
</p>
<p>
    <strong>4.</strong>
    <strong>
        4. Aceptación, confirmación y validez de apuestas
    </strong>
</p>
<p>
    <strong>5.</strong> <strong>5. Tipos de apuestas</strong>
</p>
<p>
    <strong>6.</strong>
    <strong>
        6. Mercados y reglas comunes (Moneyline, Spread, Totals, Asian, Props)
    </strong>
</p>
<p>
    <strong>7.</strong> <strong>7. Bet Builder / Same Game Parlay</strong>
</p>
<p>
    <strong>8.</strong> <strong>8. Apuestas en vivo (Live Betting)</strong>
</p>
<p>
    <strong>9.</strong> <strong>9. Cashout</strong>
</p>
<p>
    <strong>10.</strong>
    <strong>
        10. Regla de 25 horas, eventos pospuestos/cancelados y cambios de
        horario
    </strong>
</p>
<p>
    <strong>11.</strong>
    <strong>
        11. Resultados oficiales, correcciones posteriores y re-liquidaciones
    </strong>
</p>
<p>
    <strong>12.</strong>
    <strong>
        12. Futures/Outrights, retiros y criterios de campeón
    </strong>
</p>
<p>
    <strong>13.</strong>
    <strong>
        13. Dead Heat Rule (empates en posiciones)
    </strong>
</p>
<p>
    <strong>14.</strong>
    <strong>
        14. Errores evidentes, fallas técnicas e integridad del mercado
    </strong>
</p>
<p>
    <strong>15.</strong> <strong>15. Reglas antifraude y uso indebido</strong>
</p>
<p>
    <strong>16.</strong> <strong>16. Reglas por deporte (detalladas)</strong>
</p>
<p>
    <strong>17.</strong>
    <strong>
        17. Disputas, auditoría y canal de reclamos
    </strong>
</p>
<p>
    <strong>18.</strong> <strong>18. Modificación de reglas y vigencia</strong>
</p>
<br clear="all"/>
<h1>
    1. INTRODUCCIÓN Y ALCANCE
</h1>
<p>
    1.1 Estas reglas regulan la aceptación, validación, liquidación (settlement)
    y resolución de disputas relacionadas con apuestas deportivas en TAR.LA.
</p>
<p>
    1.2 TAR.LA puede ofrecer mercados prematch y en vivo (live). Los mercados
    disponibles pueden variar por deporte, liga, región, y condiciones de riesgo
    e integridad.
</p>
<p>
    1.3 El Jugador es responsable de revisar el mercado, el periodo (partido
    completo, 1er tiempo, 1er cuarto, etc.) y el tipo de cuota antes de
    confirmar el ticket.
</p>
<h1>
    2. DEFINICIONES
</h1>
<p>
    Jugador: Usuario registrado que realiza apuestas en la plataforma.
</p>
<p>
    Evento: Competencia deportiva (partido, carrera, serie, torneo) sobre la
    cual se ofrecen mercados.
</p>
<p>
    Mercado: Resultado o variable específica ofrecida para apostar (ganador,
    totales, hándicap, props, etc.).
</p>
<p>
    Selección: Opción elegida por el Jugador dentro de un mercado.
</p>
<p>
    Cuota (Odds): Valor numérico que determina el pago potencial.
</p>
<p>
    Stake: Monto apostado por el Jugador.
</p>
<p>
    Prematch: Apuesta realizada antes del inicio del evento.
</p>
<p>
    Live / En vivo: Apuesta realizada durante el desarrollo del evento.
</p>
<p>
    Push/Void: Apuesta anulada que se liquida con cuota 1.00 devolviendo el
    stake.
</p>
<p>
    Spread/Handicap: Ventaja o desventaja aplicada al marcador para fines de
    apuesta.
</p>
<p>
    Asian Handicap: Hándicap asiático que puede ser fraccionado y generar half
    win/half loss.
</p>
<p>
    Totals (O/U): Apuesta al total de puntos/goles/carreras.
</p>
<p>
    Props: Mercados de desempeño/estadísticas (equipo o jugador).
</p>
<p>
    Futures/Outrights: Apuestas de largo plazo (campeón, ganador de torneo,
    etc.).
</p>
<p>
    Bet Builder/SGP: Combinación de selecciones dentro del mismo evento.
</p>
<p>
    Cashout: Función opcional para cerrar una apuesta antes del final, cuando
    esté disponible.
</p>
<h1>
    3. PRINCIPIOS GENERALES Y EVIDENCIAS
</h1>
<p>
    3.1 Resultados oficiales: Las apuestas se liquidan con base en resultados y
    estadísticas oficiales de la liga/federación/organizador.
</p>
<p>
    3.2 Tiempo aplicable: Por defecto, tiempo reglamentario + tiempo añadido.
    Prórroga/OT/penales solo cuentan si el mercado lo indica.
</p>
<p>
    3.3 Registros internos: En cualquier disputa prevalece el registro interno
    del sistema (ticket, hora de aceptación, cuota confirmada, estado del
    mercado, logs).
</p>
<p>
    3.4 Mercado y periodo: Un mismo evento puede tener mercados por partido
    completo y por periodos. Cada mercado se liquida según su propia
    descripción.
</p>
<h1>
    4. ACEPTACIÓN, CONFIRMACIÓN Y VALIDEZ DE APUESTAS
</h1>
<p>
    4.1 Una apuesta se considera aceptada solo cuando el sistema confirme el
    ticket como “Aceptado/Confirmado”. Tickets “Pendientes” pueden ser
    rechazados.
</p>
<p>
    4.2 Cuotas dinámicas: Las cuotas pueden cambiar en cualquier momento. Si
    cambian antes de la confirmación, el sistema podrá solicitar aceptación de
    la nueva cuota.
</p>
<p>
    4.3 Rechazo/limitación: TAR.LA puede rechazar o limitar apuestas por motivos
    técnicos, integridad, riesgo, correlación, límites por liga/mercado o
    políticas antifraude.
</p>
<p>
    4.4 Duplicidad y correlación: TAR.LA puede invalidar combinaciones
    correlacionadas no permitidas (ej. selecciones que dependan del mismo suceso
    de forma artificial).
</p>
<h1>
    5. TIPOS DE APUESTAS
</h1>
<h2>
    5.1 Straight Bet (Apuesta simple)
</h2>
<p>
    Apuesta a una única selección. Se liquida como ganadora, perdedora o
    Push/Void según el resultado oficial y reglas del mercado.
</p>
<h2>
    5.2 Parlay / Multiple (Apuesta combinada)
</h2>
<p>
    Combina dos o más selecciones. Para ganar, todas deben resultar ganadoras.
</p>
<p>
    Si una selección se declara Push/Void, se recalcula el parlay con cuota 1.00
    para dicha selección, salvo que el sistema indique otra regla.
</p>
<h2>
    5.3 System Bets (Sistemas)
</h2>
<p>
    Los sistemas generan combinaciones internas (p. ej., 2/3, 3/4). El stake se
    divide entre combinaciones.
</p>
<p>
    Cada combinación se liquida de forma independiente. Selecciones Push/Void se
    tratan como cuota 1.00.
</p>
<h2>
    5.4 Teaser Bets
</h2>
<p>
    Permiten ajustar líneas de spread y/o totales en deportes permitidos a
    cambio de menor cuota.
</p>
<p>
    Reglas de puntos de ajuste, tratamiento de pushes y deportes permitidos se
    muestran en la interfaz al apostar.
</p>
<h2>
    5.5 Chain Bets
</h2>
<p>
    Apuesta encadenada: la ganancia potencial de una selección pasa como stake a
    la siguiente.
</p>
<p>
    Push/Void se considera cuota 1.00 para el cálculo de la cadena, salvo regla
    distinta del producto.
</p>
<h2>
    5.6 Multiway Bets
</h2>
<p>
    Mercados con más de dos resultados (ganador de torneo, podio, etc.). Puede
    aplicar Dead Heat (ver Sección 13).
</p>
<h1>
    6. MERCADOS Y REGLAS COMUNES
</h1>
<h2>
    6.1 Moneyline / Ganador
</h2>
<p>
    Apuesta al ganador del evento o periodo indicado. En deportes con empate
    puede existir mercado 1X2 o mercado de dos vías (sin empate).
</p>
<h2>
    6.2 Spread / Handicap
</h2>
<p>
    Se aplica la línea al marcador del tiempo aplicable. Si la línea es entera y
    el resultado ajustado empata, la apuesta es Push.
</p>
<h2>
    6.3 Totals (Over/Under)
</h2>
<p>
    Apuesta al total combinado. Si el total coincide exactamente con una línea
    entera, el resultado es Push.
</p>
<p>
    En totales asiáticos fraccionados, el stake se divide y puede resultar half
    win/half loss.
</p>
<h2>
    6.4 Asian Handicap
</h2>
<p>
    Líneas fraccionadas dividen el stake en dos partes. Ejemplos:
</p>
<p>
    - -0.25 = -0.0 y -0.5 (empate: mitad Push, mitad pérdida).
</p>
<p>
    - +0.75 = +0.5 y +1.0 (pierde por 1: mitad Push, mitad pérdida).
</p>
<p>
    Liquidación: win/half win/push/half loss/loss.
</p>
<h2>
    6.5 Player Props y Team Props
</h2>
<p>
    Se liquidan según estadísticas oficiales. Si el jugador no participa, el
    mercado puede ser Void salvo que indique “acción” o regla distinta.
</p>
<p>
    Props por periodos requieren completar el periodo para liquidar mercados no
    resueltos, salvo que ya estén definidos.
</p>
<h1>
    7. BET BUILDER / SAME GAME PARLAY
</h1>
<p>
    Permite combinar selecciones del mismo evento. TAR.LA puede restringir
    combinaciones correlacionadas no permitidas.
</p>
<p>
    Si una selección se Void, el sistema intentará recalcular el ticket; si no
    es posible, TAR.LA podrá declarar Void el ticket completo.
</p>
<h1>
    8. APUESTAS EN VIVO (LIVE BETTING)
</h1>
<p>
    8.1 Delays: puede existir retraso entre solicitud y aceptación.
</p>
<p>
    8.2 Suspensión: mercados pueden suspenderse ante VAR, penalty, tarjeta roja,
    lesión, interrupción, cambios bruscos de cuota o integridad del feed.
</p>
<p>
    8.3 Fuera de tiempo: apuestas realizadas después de un evento determinante
    (gol/punto/try) podrán anularse.
</p>
<p>
    8.4 Feed vs transmisión: diferencias de latencia del Jugador no otorgan
    derecho a cancelación; prevalece el registro del sistema.
</p>
<h1>
    9. CASHOUT
</h1>
<p>
    Cashout es una función opcional. Puede no estar disponible en todos los
    mercados o momentos.
</p>
<p>
    El valor ofrecido depende de probabilidades actuales, margen y exposición.
    Puede variar o desaparecer sin previo aviso.
</p>
<h1>
    10. REGLA DE 25 HORAS, EVENTOS POSPUESTOS/CANCELADOS Y CAMBIOS DE HORARIO
</h1>
<p>
    10.1 Regla de 25 horas (proveedor): si el evento pospuesto se celebra dentro
    de 25 horas del horario original, apuestas prematch permanecen válidas.
</p>
<p>
    10.2 Si no se celebra dentro de 25 horas, apuestas no resueltas se declaran
    Void y se devuelve stake con cuota 1.00.
</p>
<p>
    10.3 Cambios de fecha/hora por el organizador no invalidan apuestas por sí
    mismos.
</p>
<p>
    10.4 Mercados ya resueltos antes de suspensión/cancelación se liquidan como
    resueltos.
</p>
<h1>
    11. RESULTADOS OFICIALES, CORRECCIONES POSTERIORES Y RE-LIQUIDACIONES
</h1>
<p>
    11.1 Se utiliza el resultado oficial publicado inmediatamente tras la
    finalización del evento.
</p>
<p>
    11.2 Correcciones posteriores (sanciones, dopaje, protestas) no alterarán
    liquidaciones ya realizadas, salvo exigencia legal u orden competente.
</p>
<p>
    11.3 Si se detecta un error de aplicación del resultado oficial, TAR.LA
    podrá corregir la liquidación conservando evidencia del cambio.
</p>
<h1>
    12. FUTURES/OUTRIGHTS, RETIROS Y CRITERIOS DE CAMPEÓN
</h1>
<p>
    12.1 Si un participante se retira/abandona un torneo después de iniciado,
    apuestas relacionadas se consideran perdedoras, salvo que el mercado indique
    lo contrario.
</p>
<p>
    12.2 Si un torneo se cancela sin campeón oficial, el mercado se declara
    Void.
</p>
<p>
    12.3 Criterios como “campeón” o “máximo anotador” se liquidan según la
    publicación oficial del organizador.
</p>
<h1>
    13. DEAD HEAT RULE
</h1>
<p>
    Cuando dos o más participantes empatan en una posición relevante para un
    mercado multiway, el pago se prorratea.
</p>
<p>
    Ejemplo: Si 2 participantes empatan por el 1er lugar, el stake se divide
    entre 2 para el cálculo del retorno.
</p>
<h1>
    14. ERRORES EVIDENTES, FALLAS TÉCNICAS E INTEGRIDAD
</h1>
<p>
    14.1 TAR.LA puede anular apuestas por errores evidentes en cuotas, líneas,
    nombres, periodos o configuración del mercado, incluso después de finalizado
    el evento.
</p>
<p>
    14.2 Un error evidente incluye cuotas manifiestamente fuera de rango,
    inversión de favoritos, mercado duplicado mal configurado o feed incorrecto.
</p>
<p>
    14.3 Fallas de conectividad del Jugador o su dispositivo no invalidan una
    apuesta aceptada correctamente.
</p>
<h1>
    15. REGLAS ANTIFRAUDE Y USO INDEBIDO
</h1>
<h2>
    15.1 Bots y automatización
</h2>
<p>
    Se prohíbe el uso de bots, scripts, scraping o automatización para apostar o
    extraer datos. TAR.LA podrá limitar cuentas, anular apuestas y cerrar
    cuentas asociadas.
</p>
<h2>
    15.2 Arbitrage, abuso de promociones y patrones anómalos
</h2>
<p>
    Estrategias de arbitraje destinadas a explotar diferencias de cuotas, abuso
    sistemático de bonos o patrones anómalos podrán resultar en limitaciones,
    anulación de apuestas y/o revisión de cuenta.
</p>
<h2>
    15.3 Syndicates, colusión y manipulación
</h2>
<p>
    TAR.LA podrá revisar apuestas de grupos organizados (syndicates), colusión o
    indicios de match-fixing. Podrá suspender mercados y retener pagos conforme
    a Términos y Condiciones.
</p>
<h2>
    15.4 Identidad, multi-cuentas y métodos de pago
</h2>
<p>
    Multi-cuentas, suplantación o uso de métodos de pago de terceros pueden
    conllevar anulación de apuestas y cierre de cuenta.
</p>
<h2>
    15.5 Integridad de eventos y ligas menores
</h2>
<p>
    En ligas de mayor riesgo (ligas menores/juveniles), TAR.LA puede aplicar
    límites reducidos, suspender mercados o void apuestas ante alertas de
    integridad.
</p>
<h1>
    16. REGLAS POR DEPORTE (DETALLADAS)
</h1>
<h2>
    16.1 FÚTBOL
</h2>
<p>
    Para los juegos de soccer puede haber 4 diferentes tipos de líneas:
</p>
<ol start="1" type="1">
    <li>
        <strong>Línea de Gol:</strong>(90 minutos: 1er tiempo + 2do tiempo +
        tiempo de reposición)
    </li>
</ol>
<p>
    Incluye 1er tiempo + 2do tiempo + tiempo de reposición. No incluye tiempo
    extra ni penales después los 90-minutos oficiales. Usted puede apostar en el
    equipo A, equipo B o en un empate.
</p>
<ol start="2" type="1">
    <li>
        <strong>Para levantar la copa:</strong>Incluye los 90 minutos del tiempo
        reglamentario más cualquier lesión o prórroga jugada. Usted apuesta por
        el equipo que avanzará o será declarado ganador del partido, por lo
        tanto, cualquier tiroteo ayuda a determinar el ganador. Un equipo debe
        ganar el partido.
    </li>
</ol>
<ol start="3" type="1">
    <li>
        <strong>Three way result:</strong>(90-minutos: 1er tiempo + 2do tiempo +
        tiempo de reposición):
    </li>
</ol>
<p>
    Incluye 1er tiempo + 2do tiempo + tiempo de reposición. No incluye tiempo
    extra ni penales después los 90-minutos oficiales. Usted puede apostar en el
    equipo A, equipo B o en un empate.
</p>
<ol start="4" type="1">
    <li>
        <strong>Total:</strong>(90-minutos: 1er tiempo + 2do tiempo + tiempo de
        reposición):
    </li>
</ol>
<p>
    Incluye 1er y 2do tiempo más tiempo de reposición. No incluye penales
    después de los 90 minutos ni tiempo extra a menos que se especifique lo
    contrario.
</p>
<ol start="5" type="1">
    <li>
        <strong>Marcador correcto:</strong>(90-minutos: 1er tiempo + 2do tiempo
        + tiempo de reposición): Incluye 1er y 2do tiempo más tiempo de
        reposición. No incluye penales después de los 90 minutos ni tiempo extra
        a menos que se especifique lo contrario.
    </li>
    <li>
        <strong>Resultado doble:</strong>(1era mitad + resultado del juego):
        incluye al 1ra y la 2da mitad + tiempo de reposición. No incluye penales
        después de los 90 minutos ni tiempo extra a menos que se especifique lo
        contrario.
    </li>
    <li>
        <strong>Margen de Victoria:</strong>(90-minutos: 1er tiempo + 2do tiempo
        + tiempo de reposición):
    </li>
</ol>
<p>
    Incluye 1er y 2do tiempo y tiempo de reposición. No incluye penales después
    de los 90 minutos ni tiempo extra a menos que se especifique lo contrario.
</p>
<ol start="8" type="1">
    <li>
        Props en futbol:
    </li>
</ol>
<ul type="disc">
    <li>
        El jugador tiene que jugar para tener acción.
    </li>
    <li>
        Todos los PROPS son para el tiempo de regulación de 90 minutos más el
        tiempo de reposición, NO incluyen tiempos extra o tandas de penales, a
        menos que se especifique lo contrario.
    </li>
    <li>
        Para el prop «equipo que anota de ultimo» un segundo gol tiene que
        constarse para tener acción.
    </li>
</ul>
<ol start="9" type="1">
    <li>
        <strong>Gol Tempranero/Tardío</strong>
    </li>
</ol>
<p>
    La calificación de estos props se determinará con el tiempo proporcionado
    por el sitio web oficial, no por la hora real en que se produjo el gol. En
    fútbol, si se marca un gol a las 22:35, la hora oficial para ese gol será
    las 23:00.
</p>
<p>
    Por ejemplo, si el tiempo puesto del Gol Tempranero era 26:00 y el gol fue
    hecho a la 25:20, haciendo que la hora oficial de ese gol fuera a las 26:00,
    entonces el NO GOL ANTES DE 26:00 sería el ganador.
</p>
<p>
    <strong>Líneas Asian Handicap</strong>
</p>
<p>
    <strong>Linea de Gol ¼ (0.25).</strong>
</p>
<p>
    <strong>Equipo -¼ (-0.25) goles:</strong>
</p>
<p>
    Gane por cualquier resultado. Todas las apuestas son ganadoras. Empate:
    Mitad del dinero en riesgo se reintegra. La otra mitad se declara como
    perdedora. Perdida por cualquier resultado: Todas las apuestas son
    perdedoras.
</p>
<p>
    <strong>Equipo +¼</strong> (+0.25) goles:
</p>
<p>
    Gane por cualquier resultado. Todas las apuestas son ganadoras. Empate : La
    mitad de la apuesta gana al precio fijado. La otra mitad se reembolsa.
    Perdida por cualquier resultado. Todas las apuestas son perdedoras.
</p>
<p>
    <strong>Línea de Gol ½ (0.5).</strong>
</p>
<p>
    <strong>Equipo -½</strong>(-0.5) goles:
</p>
<p>
    Gane por cualquier resultado: Todas las apuestas son ganadoras. Empate:
    Todas las apuestas son perdedoras. Perdida por cualquier resultado: Todas
    las apuestas son perdedoras.
</p>
<p>
    <strong>Equipo +½</strong> (+0.5) goles:
</p>
<p>
    Gane por cualquier resultado: Todas las apuestas son ganadoras. Empate:
    Todas las apuestas son ganadoras. Perdida por cualquier resultado: Todas las
    apuestas son perdedoras.
</p>
<p>
    <strong>Línea de Gol ¾ (0.75)</strong>
</p>
<p>
    <strong>Equipo -¾</strong> (-0.75) goles:
</p>
<p>
    Gane por 2 o más: Todas las apuestas son ganadoras. Gane por exactamente 1
    gol : La mitad de la apuesta gana al precio fijado. La otra mitad se
    reembolsa. Empate o perdida por cualquier resultado: Todas las apuestas son
    perdedoras.
</p>
<p>
    <strong>Equipo +¾</strong> (+0.75) goles:
</p>
<p>
    Empate o gane por cualquier resultado: Todas las apuestas son ganadoras.
    Pérdida por exactamente 1 gol: Mitad de dinero en riesgo se reembolsa. La
    otra mitad se declara perdedora. Pérdida por dos o mas goles: Todas las
    apuestas son perdedoras.
</p>
<p>
    <strong>Línea de Gol 1.</strong>
</p>
<p>
    <strong>Equipo -1 gol:</strong>
</p>
<p>
    Gane por dos o más: Todas las apuestas son ganadoras. Gane por exactamente
    un gol: Todas las apuestas son reembolsadas. Empate o pérdida: Todas las
    apuestas son perdedoras.
</p>
<p>
    <strong>Equipo +1 goals:</strong>
</p>
<p>
    Gane por cualquier resultado y empate: Todas las apuestas son ganadoras.
    Perdida por exactamente 1 gol: Todas las apuestas son reembolsadas. Perdida
    por 2 o más goles: Todas las apuestas son perdedoras.
</p>
<p>
    <strong>Línea de Gol 1 ¼ (1.25).</strong>
</p>
<p>
    <strong>Equipo -1 ¼</strong> (-1.25) goals:
</p>
<p>
    Gane por dos o mas goles: Todas las apuestas son ganadoras. Gane por
    exactamente 1 gol. La mitad del dinero en riesgo se reembolsa. La otra mitad
    se declara perdedora. Empate o pérdida por cualquier resultado. Todas las
    apuestas son perdedoras.
</p>
<p>
    <strong>Equipo +1 ¼</strong> (+1.25) goles:
</p>
<p>
    Gane por cualquier resultado o empate: Todas las apuestas son ganadoras.
    Pérdida por exactamente 1 gol: La mitad de la apuesta gana al precio fijado.
    La otra mitad se reembolsa. Pérdida por 2 o mas goles. Todas las apuestas
    son perdedoras.
</p>
<p>
    <strong>Línea de goles 1 ½ (1.5).</strong>
</p>
<p>
    <strong>Equipo -1 ½</strong> (-1.5) goles:
</p>
<p>
    Gane por dos o mas goles: Todas las apuestas son ganadoras. Gane por
    exactamente 1 gol, empate o pérdida por cualquier marcador: Todas las
    apuestas son perdedoras.
</p>
<p>
    <strong>Equipo +1 ½</strong> (+1.5) goals:
</p>
<p>
    Pérdida por exactamente 1 gol, empate o gane con cualquier resultado: Todas
    las apuestas son ganadoras. Pérdida por dos o mas goles: Todas las apuestas
    son perdedoras.
</p>
<p>
    <strong>Línea de goles 1 ¾ (1.75) goles.</strong>
</p>
<p>
    <strong>Equipo -1 ¾</strong> (-1.75) goles:
</p>
<p>
    Gane por 3 o mas goles: Todas las apuestas son ganadoras. Gane por
    exactamente 2 goles: La mitad de la apuesta gana al precio fijado. La otra
    mitad se reembolsa. Gane por un gol, empate o pérdida por cualquier
    marcador: Todas las apuestas son perdedoras.
</p>
<p>
    <strong>Equipo +1 ¾</strong> (+1.75) goles:
</p>
<p>
    Pérdida por 1 gol , empate o gane por cualquier resultado: Todas las
    apuestas so ganadoras. Pérdida por exactamente 2 goles Mitad de dinero en
    riesgo se reembolsa. La otra mitad se declara perdedora. Pérdida por 3 o más
    goles : Todas las apuestas son perdedoras.
</p>
<p>
    <strong>Línea de goles 2.</strong>
</p>
<p>
    <strong>Equipo -2</strong> goles:
</p>
<p>
    Gane por 3 o más goles: Todas las apuestas son ganadoras. Gane por
    exactamente 2 goles: Todas las apuestas se reembolsan. Gane por 1 gol,
    empate o pérdida por cualquier resultado: Todas las apuestas son perdedoras.
</p>
<p>
    <strong>Equipo +2</strong> goals:
</p>
<p>
    Pérdida por 1 gol, empate o gane por cualquier resultado: Todas las apuestas
    son ganadoras. Pérdida por exactamente 2 goles: Todas las apuestas se
    reembolsan. Pérdida por 3 o más goles: Todas las apuestas son perdedoras.
</p>
<p>
    <strong>Totales Asian Handicap</strong>
</p>
<p>
    <strong>Abajo ½</strong> Con 0 goles marcados en el partido, la apuesta es
    ganadora; con 1 o más goles en el partido, la apuesta es perdedora. Arriba ½
    Con 0 goles marcados en el partido, la apuesta es perdedora; con 1 o más
    goles en el partido, la apuesta es ganadora.
</p>
<p>
    <strong>Abajo ¾</strong> Con 0 goles marcados en el partido, la apuesta es
    ganadora; con 1 gol marcado en el partido, la mitad de la apuesta pierde;
    con 2 o más goles en el partido, la apuesta es perdedora. Arriba ¾ Con 0
    goles marcados en el partido, la apuesta es perdedora; con 1 gol marcado en
    el partido, la mitad de la apuesta gana; con 2 o más goles en el partido, la
    apuesta es ganadora.
</p>
<p>
    <strong>Abajo 1¼</strong> Con 0 goles marcados en el partido, la apuesta es
    ganadora; con 1 gol marcado en el partido, la mitad de apuesta gana; con 2 o
    más goles en el partido, la apuesta es perdedora. Arriba 1¼ Con 0 goles
    marcados en el partido, la apuesta pierde; con 1 gol marcado en el partido,
    la mitad de la apuesta pierde; con 2 o más goles en el partido, la apuesta
    es ganadora.
</p>
<p>
    <strong>Abajo 1 ½</strong> Con 0 o 1 gol en el partido, la apuesta es
    ganadora; con 2 o más goles en el partido la apuesta es perdedora. Arriba 1
    ½ Con 0 o 1 gol en el partido, la apuesta es perdedora; con 2 o más goles,
    la apuesta es ganadora.
</p>
<p>
    <strong>Abajo 1¾</strong> Con 0 o 1 gol en el partido, la apuesta es
    ganadora; con 2 goles en el partido, la mitad de la apuesta pierde; con 3 o
    más goles en el partido la apuesta es perdedora. Arriba 1¾ Con 0 o 1 gol en
    el partido, la apuesta es perdedora; con 2 goles en el partido la mitad de
    la apuesta es ganadora; con 3 o más goles, la apuesta es ganadora.
</p>
<p>
    <strong>Abajo 2¼</strong> Con 0 o 1 gol en el partido, la apuesta es
    ganadora; con 2 goles en el partido, la mitad de la apuesta es ganadora; con
    3 o más goles en el partido, la apuesta es perdedora. Arriba 2¼ Con 0 o 1
    gol la apuesta es perdedora; con 2 goles en el partido la mitad de la
    apuesta pierde; con 3 o más goles la apuesta es ganadora.
</p>
<p>
    <strong>Under 2 ½</strong> Con 0, 1 o 2 goles, la apuesta es ganadora; con 3
    o más goles la apuesta es perdedora. Arriba 2 ½ Con 0, 1 o 2 goles en el
    partido, la apuesta es perdedora; con 3 o más goles, la apuesta es ganadora.
</p>
<p>
    <strong>Under 2¾</strong> Con 0, 1 o 2 goles, la apuesta es ganadora; con 3
    goles en el partido la mitad de la apuesta pierde; con 4 o más goles la
    apuesta es perdedora. Arriba 2¾ Con 0, 1 o 2 goles en el partido, la apuesta
    es perdedora; con 3 goles en el partido, la mitad de la apuesta gana; con 4
    o más goles, la apuesta es ganadora.
</p>
<ul type="disc">
    <li>
        Se aplican las mismas reglas para cualquier líneas de asian handicap
        superior a -2 ¼, -3 ¾, etc.
    </li>
    <li>
        Los totales de fútbol que utilizan líneas de Handicap asiático también
        siguen los mismos principios de ¼ de goles para la clasificación.
    </li>
    <li>
        En caso de un parlay con línea de hándicap asiático, el pick será
        eliminado y el parlay revertirá al menor número de equipos. Ejemplo 2
        Los parlays de equipo se convierten en jugadas directas. 3 Equipos
        combinados se convierten en 2 Equipos combinados.
    </li>
</ul>
<h2>
    16.2 BALONCESTO
</h2>
<ul>
    <li>
        Tiempo aplicable: incluye overtime salvo que el mercado indique lo
        contrario.
    </li>
    <li>
        Mercados: Moneyline, Spread, Totals, por cuartos/mitades, props de
        jugadores (puntos, rebotes, asistencias, triples, etc.).
    </li>
    <li>
        Props: se liquidan por estadísticas oficiales; si el jugador no
        participa, el mercado puede ser Void.
    </li>
    <li>
        Partido suspendido: mercados no resueltos pueden ser Void si no hay
        resultado oficial.
    </li>
</ul>
<ul type="disc">
    <li>
        Las líneas para el 4o Cuarto NO incluyen tiempos extra.
    </li>
    <li>
        Las Quinielas (Pools) de Doble Resultado consisten en el ganador del 1er
        tiempo y el ganador del partido.
    </li>
    <li>
        Las Quinielas (Pools) para ambos Doble Resultado y Margen de Victoria
        incluyen tiempos extra.
    </li>
</ul>
<ul>
    <li>
        * Las apuestas del Segundo Tiempo siempre incluyen tiempos extra.
    </li>
</ul>
<h2>
    16.3 BÉISBOL
</h2>
<ul type="disc">
    <li>
        Los juegos son oficiales después de 5 entradas de juego a menos que el
        equipo local esté ganando después de 4 entradas y media.
    </li>
    <li>
        Después de 5 entradas de juego, si el juego es llamado o suspendido, la
        puntuación final (para propósitos de apuesta) se determina por la última
        entrada completa de juego a menos que el equipo local anota para empatar
        o tome la delantera en la mitad inferior de la entrada. En cuyo caso, el
        ganador se determina por la puntuación cuando se llama al juego
    </li>
    <li>
        Los Juegos de Temporada Regular que se suspenden o posponen no se
        transfieren al día siguiente. Sin embargo, para la postemporada de la
        MLB, la final del Clásico Mundial de Béisbol (WBC) y los juegos de
        Semifinales, Post temporada de baseball internacional y finales World
        series de pequeñas ligas que se suspenden o posponen, las apuestas se
        transferirán hasta que el juego se pronuncie como definitivo.
    </li>
    <li>
        Los juegos de la Serie Mundial Universitaria que están suspendidos se
        consideran en un largo retraso de lluvia y serán calificados cuando el
        juego llegue a su final oficial.
    </li>
    <li>
        Partidos MLB Programados a 7 Innings : Para que las apuestas en la Línea
        de Carreras y en el Total sean válidas se deben de completar los 7
        innings o 6.5 si el equipo casa va ganado.
    </li>
    <li>
        Cualquier partido de baseball Mexicano debe ser completado en al menos
        en 8.5 entradas si el equipo casa está ganando o 9 entradas si no es así
        para que la línea de la carrera y el total tengan acción.
    </li>
    <li>
        Los juegos de exhibición serán juegos de 9 entradas o pueden acortarse a
        juegos de 7 entradas o juegos de 5 entradas por mutuo acuerdo de ambos
        directores.
    </li>
    <li>
        Los juegos acortados serán tratados como juegos acortados por lluvia.
    </li>
</ul>
<p>
    <strong>Líneas de Béisbol</strong>
</p>
<p>
    Los juegos de Béisbol se pueden apostar de tres maneras diferentes: Línea de
    dinero, Línea de carrera y Totales. Para las líneas de carreras y Totales
    utilizamos una línea de 20 centavos. El favorito tiene el número negativo al
    lado que muestra el precio que tiene que poner para jugar ese lado y el
    desfavorable casi siempre tiene un número positivo al lado que muestra el
    precio que ganaría jugando. A continuación se muestra un ejemplo de un juego
    de béisbol típico.
</p>
<table border="0" cellpadding="0">
    <tbody>
        <tr>
            <td width="207">
                <p>
                    EQUIPOS
                </p>
            </td>
            <td width="207">
                <p>
                    LINEA DEL DINERO
                </p>
            </td>
            <td width="207">
                <p>
                    TOTAL
                </p>
            </td>
        </tr>
        <tr>
            <td width="207">
                <p>
                    Mets – Hampton
                </p>
            </td>
            <td width="207">
                <p>
                    -134
                </p>
            </td>
            <td width="207">
                <p>
                    9ov -105
                </p>
            </td>
        </tr>
        <tr>
            <td width="207">
                <p>
                    Marlins – Dempster
                </p>
            </td>
            <td width="207">
                <p>
                    +124
                </p>
            </td>
            <td width="207">
                <p>
                    9ov -105
                </p>
            </td>
        </tr>
    </tbody>
</table>
<ul type="disc">
    <li>
        Si quiere hacer una apuesta de $100 en los Mets, estaría arriesgando
        $134 para ganar $100.
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en los Marlins, estaría arriesgando
        $100 para ganar $124.
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en las altas de 9 carreras, estaría
        arriesgando $105 para ganar $100
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en las bajas de 9 carreras, estaría
        arriesgando $115 para ganar $100.
    </li>
</ul>
<p>
    Al apostar Líneas de Dinero de Béisbol, puede elegir las siguientes opciones
    para sus apuestas: ACCIÓN, LISTADOS, o puede escoger solamente el lanzador
    de SU EQUIPO o el EQUIPO OPUESTO.
</p>
<p>
    En MLB cuando un equipo tenga ACTION como su lanzador, entonces sin importar
    el lanzador que inicie la jugada tendrá acción.
</p>
<p>
    NOTA: Los lanzadores iniciales se determinan después del primer paso. En
    caso de un cambio de lanzadores antes del juego, el precio del dinero puede
    ajustarse y su apuesta puede cambiar si juega con acción.
</p>
<p>
    <strong>Acción:</strong>
</p>
<p>
    Su apuesta es equipo contra equipo, independientemente de quiénes sean los
    lanzadores titulares. En caso de un cambio de lanzadores, su precio se
    ajustará al número de apertura del lanzador inicial real.
</p>
<p>
    <strong>Lanzadores Listados:</strong>
</p>
<p>
    Su apuesta se basa en ambos lanzadores listados lanzando al menos una vez al
    inicio del juego para que usted tenga acción. Ambos lanzadores deben
    comenzar para que usted tenga acción en su apuesta, de lo contrario la
    apuesta será declarada SIN ACCIÓN después de que el juego termine.
</p>
<p>
    <strong>Lanzador de su equipo:</strong>
</p>
<p>
    Solo está tomando el lanzador listado del equipo en el que está apostando.
    El lanzador seleccionado debe iniciar el juego para que su apuesta cuente.
    Cualquier lanzador puede empezar para el equipo contrario. En caso de un
    cambio de lanzador en el equipo contrario, el precio seguirá siendo ajustado
    al precio de apertura de los titulares listados al principio.
</p>
<p>
    <strong>Lanzador Opuesto:</strong>
</p>
<p>
    Está escogiendo únicamente al lanzador del equipo contrario. Cualquier
    abridor puede lanzar para el equipo que seleccionó. El lanzador del equipo
    contrario tiene que empezar. En el caso de un cambio de lanzador en su
    equipo, el precio se ajustará al precio de apertura de los titulares
    listados al principio.
</p>
<p>
    La otra forma de apostar en un partido de béisbol es apostar la línea de
    carrera. Cada favorito será – 1 1/2 carreras y podría ser más o menos
    dinero. A continuación se muestra un ejemplo de cómo se ve una línea de
    carreras:
</p>
<table border="0" cellpadding="0">
    <tbody>
        <tr>
            <td width="311">
                <p>
                    Mets – Hampton
                </p>
            </td>
            <td width="311">
                <p>
                    +1 ½ +115
                </p>
            </td>
        </tr>
        <tr>
            <td width="311">
                <p>
                    Marlins – Dempster
                </p>
            </td>
            <td width="311">
                <p>
                    -1 ½ -135
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p>
    Si usted apuesta $100 en los Mets, tiene a los Mets +1½ carreras, arriesga
    $100 para ganar $115
</p>
<p>
    Al apostar en Total de Carreras (Altas/Bajas) y Líneas de Carrera, el juego
    debe hacer 9 entradas (8 1/2 si el equipo local está ganando).
</p>
<p>
    Si el juego se suspende después de 9 entradas, la puntuación final (para
    propósitos de apuesta) se determina por la última entrada completa de juego
    a menos que el equipo local anote para empatar o tome la delantera en la
    mitad inferior de la entrada. En cuyo caso, el ganador se determina por la
    puntuación cuando se detiene el juego. Si con estas reglas el juego es un
    EMPATE, las Líneas de Carreras y Totales son válidas. Todas las puestas en
    Totales y Líneas de Carrera son SIEMPRE con los Lanzadores Listados. Si
    ambos lanzadores programados para lanzar en el momento de la apuesta no
    lanzan al menos una vez al iniciar el Partido, la apuesta será cancelada.
    Las apuestas en Total de Carreras y las Líneas de Carreras se reembolsan en
    caso de un cambio de lanzador cuando el juego sea definitivo.
</p>
<p>
    NO aceptamos apuestas Combinadas (Parlays), Condicionadas (If Bets) o Round
    Robins con el Total y Línea de Carrera del mismo partido. Cualquier apuesta
    de este tipo puede ser cancelada por nosotros sin previo aviso.
</p>
<p>
    <strong>Regla de LLUVIA o SOL</strong>: Las proposiciones (props) de
    béisbol, incluyendo 1er puntaje, Sí/No Puntuación en la 1a entrada, las
    1eras 5 entradas, se califican tan pronto como ocurre ese evento. Para a
    línea de las 1eras 5 entradas, el partido debe de llegar a la 6ta entrada de
    juego para que la apuesta sea válida. Las apuestas son finales incluso si el
    juego se detiene por lluvia o si es suspendido.
</p>
<p>
    Para cualquier Prop, el juego debe ser jugado por completo para ser válido.
    Juegos q son programados para solo 7 Entradas (6.5 si el equipo casa está
    ganando) son considerados completos.
</p>
<p>
    <strong>LÍNEA DE 2do TIEMPO:</strong> La 2a mitad de la puntuación de
    béisbol incluye desde la parte superior de la sexta entrada hasta el final
    del juego incluyendo entradas extras. El juego debe ser completado ara que
    la apuesta sea válida (9 entradas completas u 8.5 entradas si el equipo
    local está ganando). Todas las apuestas en la 2a mitad son de acción
    independientemente del lanzador. Si los partidos se suspenden y se han
    jugado MÁS de 9 entradas, la puntuación volverá a la última entrada
    COMPLETA.
</p>
<p>
    <strong>
        Proposiciones de béisbol, las líneas de carreras alternativas y mitades
    </strong>
    , TODOS los lanzadores listados deben iniciar el juego. En la proposición de
    Jugador para obtener la Mayoría de las Bases Totales, se utiliza el
    siguiente sistema de puntuación: Singular= 1 base, Doble= 2 bases, Triple= 3
    bases, HR= 4 bases.
</p>
<p>
    Ambos jugadores lanzadores titulares deben comenzar para que la apuesta sea
    válida.
</p>
<p>
    En los eventos de la Quiniela TODOS LOS JUGADORES SON ACCIÓN a menos que se
    specifique lo contrario.
</p>
<p>
    Los Props de béisbol se pueden utilizar para Apuestas Directas, Combinadas
    (Parlays), Condicionadas y/o Round Robins (TEASERS NO) siempre y cuando el
    otro equipo en tales apuestas no pertenezca a la misma Familia. Cualquier
    apuesta dentro de la misma familia (O PROPS UTILIZADO EN TEASERS) será
    cancelada por nosotros sin previo aviso.
</p>
<p>
    <strong>Series de Béisbol:</strong> Las Series de Béisbol son partidos
    jugados entre dos equipos (Solo Temporada Regular). Ninguno de los dos
    equipos puede jugar a ningún otro oponente entre los partidos programados en
    la serie. Las siguientes son las reglas principales utilizadas para
    calificar la Serie de Béisbol:
</p>
<ul type="disc">
    <li>
        Todos los juegos de una serie cuentan para apostar. En una serie de
        cuatro juegos 2-2 es un empate.
    </li>
    <li>
        Una serie se considera válida si se ha jugado un partido.
    </li>
    <li>
        Si se detiene un juego durante la serie, este juego se considerará bueno
        para la serie siempre y cuando uno de los equipos sea declarado
        oficialmente ganador del juego.
    </li>
    <li>
        Todas las apuestas se basan en la ACCIÓN con respecto a los lanzadores
        en cada juego.
    </li>
    <li>
        Un juego suspendido de una serie anterior que se completa no se
        considera parte de la serie actual.
    </li>
    <li>
        Estas reglas pueden diferir de otros sportsbook.
    </li>
</ul>
<p>
    Así que si una serie comienza el Viernes y termina el Lunes, se calificará
    el Lunes, con todos los juegos contando para el resultado.
</p>
<p>
    <strong>Serie Mundial</strong> <strong>Universitaria</strong> (todos los
    juegos de béisbol universitarios) que están suspendidos se consideran en un
    largo retraso de lluvia y serán calificados cuando el juego llegue a su
    final oficial.
</p>
<p>
    Para el Clásico Mundial de Béisbol (WBC), durante las dos primeras rondas de
    juego, ambos líneas y totales tienen acción independientemente de la Regla
    de Misericordia. Para las Semifinales y la Final del CMB, la Regla de
    Misericordia no está en vigor, por lo tanto, los juegos seguirán las reglas
    normales de eliminatorias. En caso de discrepancia o artículos no cubiertos,
    se aplicarán las reglas de juego de Las Vegas.
</p>
<p>
    <strong>Totales, Carreras, Golpes y Errores:</strong> Un partido debe
    completar 8 entradas y media si el equipo local está ganando, o 9 si el
    equipo visitante está ganando para que la apuesta sea válida.
</p>
<p>
    <strong>GRAN SALAMI:</strong> Para las apuestas del Gran Salami, cada juego
    en el tablero tiene que ir las 9 entradas completas (81/2 si el equipo local
    está ganando) de lo contrario será cancelado.
</p>
<p>
    Los lanzadores no importan, lo que significa que si hay un cambio de
    lanzador en cualquier juego, su apuesta seguirá siendo válida.
</p>
<p>
    Para Liga de Gran Salami, solo se tendrán en cuenta los partidos jugados en
    esa liga específica, por ejemplo: el Gran Salami de la Liga Nacional solo
    incluirá partidas del calendario de la Liga Nacional y no equipos de la Liga
    Nacional que podrían estar jugando en partidas de Interliga.
</p>
<p>
    <strong>
        ** Excepción: Los juegos de béisbol de la fase final (playoffs) no
        entran en la regla de partido suspendido de acuerdo con las directrices
        de las Grandes Ligas de Béisbol para terminar todos los juegos. Si un
        partido se suspende debido al clima u oscuridad, todas las apuestas
        permanecerán pendientes hasta que el juego sea declarado definitivo.
    </strong>
</p>
<p>
    <strong>Softbol y Ligas Pequeñas</strong>
</p>
<p>
    Softbol o juegos de ligas pequeñas que terminan temprano como resultado de
    una regla de misericordia tendrán acción en todas las apuestas (a menos que
    se indique lo contrario). Si un partido se suspende o pospone debido al
    clima u oscuridad, todas las apuestas permanecerán pendientes hasta que el
    partido finalice.
</p>
<p>
    Post temporada de la NCAA --- Los juegos que terminen antes de tiempo como
    resultado de una regla de misericordia tendrán acción en todas las apuestas,
    incluidos los TOTALES (a menos que se indique lo contrario). Si un juego se
    suspende o pospone debido al clima o la oscuridad, todas las apuestas
    permanecerán pendientes hasta que el juego sea definitivo.
</p>
<p>
    Little League Baseball --- Los juegos que finalizan antes de tiempo como
    resultado de una regla de misericordia tendrán acción en todas las apuestas,
    incluidos los TOTALES (a menos que se indique lo contrario). Si un juego se
    suspende o pospone debido al clima o la oscuridad, todas las apuestas
    permanecerán pendientes hasta que el juego sea definitivo.
</p>
<h2>
    16.4 TENIS
</h2>
<p>
    Hay tres formas que ofrecemos para las apuestas de Tenis:
</p>
<ul type="disc">
    <li>
        <strong>Para Ganar el Torneo:</strong>Los clientes apuestan a que uno de
        los jugadores sea el campeón del torneo.
    </li>
    <li>
        <strong>Ganar el Partido:</strong>Elegir el jugador que el cliente cree
        que ganará el partido. El partido es oficial si se sirve una pelota.
        Después de eso, si un jugador se retira será declarado el perdedor sin
        importar la puntuación en ese momento.
    </li>
    <li>
        <strong>Proposiciones:</strong>Jugador para ganar el 1er set, Número
        total de juegos o sets, etc.
    </li>
</ul>
<p>
    <strong>Ganar el 1er set</strong> (to win set, 1st set props, etc): El
    primer set debe completarse para que todas las apuestas en el primer set
    tengan acción. Si después de que se completa el primer set, el partido se
    cancela por algún motivo, todas las apuestas del primer set se considerarán
    válidas.
</p>
<p>
    <strong>Props de emparejamiento</strong> (Juegos o Sets, puestas de
    Resultados Exactos, etc.): el partido debe completarse para que las apuestas
    tengan acción, si uno de los jugadores se retira o por otras causas el
    partido no ha terminado, todas las apuestas se considerarán INVÁLIDAS.
</p>
<p>
    Todas las apuestas de tenis son buenas incluso si la fecha del partido y la
    hora cambian debido al clima o a cualquier otra causa.
</p>
<p>
    Solo aceptamos apuestas directas en los partidos, proposiciones y futuras de
    tenis. Cualquier otra apuesta como Combinadas (Parlays), Condicionadas,
    Reversas y/o Round Robins será cancelada por nosotros.
</p>
<p>
    En caso de que un partido en progreso se retrase debido al clima u otras
    razones, la apuesta tendrá efecto hasta que se decida un ganador. Nota: El
    Sistema Automático de Apuestas en Vivo tiene su propio conjunto de reglas.
    Todos están disponibles dentro del sistema de apuestas en vivo.
</p>
<p>
    En el caso de que un partido se decida por un Súper desempate (en lugar de
    un set completo), todas las apuestas relacionadas con JUEGOS se anularán.
</p>
<p>
    Si un partido se decide de esta manera, el desempate del partido se
    considerará como el tercer set y, a efectos de las apuestas, el ganador
    obtendrá una victoria de 2-1 sets.
</p>
<h2>
    16.5 HOCKEY SOBRE HIELO
</h2>
<ul type="disc">
    <li>
        Los partidos son oficiales después de 55 minutos de juego.
    </li>
    <li>
        Las apuestas serán aceptadas usando la Línea de Gol o línea de Dinero,
        así como el Total de Goles anotados (altas/bajas) en el juego por ambos
        equipos.
    </li>
    <li>
        Se ofrecerán 2 líneas para los juegos de Hockey:
    </li>
</ul>
<ol start="1" type="1">
    <li>
        <strong>RESULTADO COMPLETO DEL JUEGO</strong>– LÍNEA DE DINERO, LÍNEA DE
        DISCO Y TOTAL: El juego debe jugarse hasta su finalización. En el caso
        de que un partido se decida en la prórroga o en una tanda de penaltis,
        se añadirá un gol a la puntuación del equipo ganador.
    </li>
    <li>
        <strong>RESULTADO DE 60 MINUTOS</strong>: LÍNEA DE DINERO, LÍNEA DE PUCK
        o LÍNEA DE GOL MÁS TOTAL: Esta apuesta se calificará después del tiempo
        reglamentario y no incluye la PRÓRROGA (tiempos extra) o PENALES. Los
        GOLES anotados en la prórroga o en los penaltis NO cuentan para ninguna
        apuesta en el RESULTADO DE 60 MINUTOS.
    </li>
</ol>
<p>
    A continuación se muestra un ejemplo de un juego típico de hockey:
</p>
<table border="0" cellpadding="0">
    <tbody>
        <tr>
            <td width="155">
                <p>
                    EQUIPO
                </p>
            </td>
            <td width="155">
                <p>
                    LINEA DEL GOL
                </p>
            </td>
            <td width="155">
                <p>
                    LINEA DEL DINERO
                </p>
            </td>
            <td width="155">
                <p>
                    TOTAL
                </p>
            </td>
        </tr>
        <tr>
            <td width="155">
                <p>
                    Penguins
                </p>
            </td>
            <td width="155">
                <p>
                    -1 1/2 +130
                </p>
            </td>
            <td width="155">
                <p>
                    -145
                </p>
            </td>
            <td width="155">
                <p>
                    5.5 -150
                </p>
            </td>
        </tr>
        <tr>
            <td width="155">
                <p>
                    Sharks
                </p>
            </td>
            <td width="155">
                <p>
                    +1 1/2 -150
                </p>
            </td>
            <td width="155">
                <p>
                    +125
                </p>
            </td>
            <td width="155">
                <p>
                    5.4 +130
                </p>
            </td>
        </tr>
    </tbody>
</table>
<ul type="disc">
    <li>
        Si quiere hacer una apuesta de $100 en los Pingüinos, estaría
        arriesgando $145 para ganar $100
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en los Sharks, arriesgaría $100 para
        ganar $125.
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en las altas de 5.5 goles,
        arriesgaría $150 para ganar $100.
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en las bajas de 5.5 goles,
        arriesgaría $100 para ganar $130.
    </li>
    <li>
        Si quiere hacer una apuesta de $100 en la línea de gol (LG) de los
        Pingüinos -1 1/2, arriesgaría $100 para ganar $130.
    </li>
</ul>
<p>
    Si quiere hacer una apuesta de $100 en LG Sharks + 1 ½ goles, arriesgaría
    $150 para ganar $100.
</p>
<p>
    Ejemplo de un juego de penaltis: Un juego entra en la prórroga (tiempos
    extra) con una puntuación de Equipo A 3 y Equipo B 3 (empatado 3-3) y sin
    puntuaciones de equipo en el período de prórroga. El ganador de los tiros de
    penaltis recibirá un gol que hará el marcador final Equipo A 4 y Equipo B 3.
    Con este resultado el total para ambos equipos combinados será de 7.
    Cualquier apuesta de 60 MINUTOS RESULTADO se decidirá con el resultado de 60
    minutos de 3-3 empate.
</p>
<p>
    Los Props de Hockey incluyendo 1a Puntuación, 1 Línea de Período se
    califican tan pronto como ocurre ese evento. Las apuestas son definitivas
    incluso si el juego se suspende.
</p>
<p>
    En las Proposiciones de Jugadores, ambos jugadores deben jugar en el partido
    para que la apuesta sea válida. En los eventos de la quiniela (pool) TODOS
    LOS JUGADORES SON VÁLIDOS a menos que se especifique lo contrario. Las
    proposiciones de hockey se pueden utilizar para Apuestas Directas,
    Combinadas (Parlays) y/o Round Robins (TEASERS NO) siempre y cuando el otro
    equipo en dichas apuestas no pertenezca a la misma familia. Cualquier
    apuesta dentro de la misma familia (O PROPS UTILIZADO EN TEASERS) será
    cancelada por nosotros sin previo aviso.
</p>
<h2>
    16.6 FÚTBOL AMERICANO
</h2>
<ul type="disc">
    <li>
        Los totales individuales de cada equipo para el segundo tiempo incluyen
        tiempos extra.
    </li>
    <li>
        Las líneas del 4to Cuarto no incluyen tiempos extra.
    </li>
    <li>
        Las Quinielas (Pools) con doble resultado consisten en el ganador del
        Primer Tiempo y el Ganador del Juego.
    </li>
    <li>
        Las Quinielas de Primer Jugada Anotadora y Margen de Victoria incluyen
        tiempos extra. Las Quinielas de Doble Resultado solamente incluyen
        tiempos extra en TEMPORADA REGULAR.
    </li>
    <li>
        En caso de que la fecha y/o el lugar del Super Tazón se cambien debido a
        condiciones climáticas severas, todas las apuestas abiertas existentes
        en el juego y las apuestas relacionadas con el juego (props) se
        considerarán de acción y siguen en pie hasta que el partido se juegue.
    </li>
</ul>
<p>
    * Debido a Covid-19 para la temporada 2020-21, todos los juegos programados
    antes del inicio de la temporada tendrán acción independientemente de si hay
    un cambio de fechas, siempre y cuando se jueguen en la ubicación
    especificada (ESTA REGLA APLICA PARA JUEGOS QUE FUERON OFRECIDOS ANTES EL
    INICIO DE LA TEMPORADA REGULAR).
</p>
<p>
    * 2ndo Tiempo y cada Cuarto deben de completarse en su totalidad para que la
    apuesta sea válida.
</p>
<p>
    * Las apuestas del Segundo Tiempo siempre incluyen tiempos extra.
</p>
<p>
    Los equipos deben jugar los 17 juegos de la temporada regular para tener
    acción, si un juego empata, se otorgará medio punto para cada equipo.
</p>
<p>
    <strong>Fútbol Universitario (CFB)</strong>
</p>
<ul type="disc">
    <li>
        Los Totales por Equipo para el Segunto Tiempo incluyen tiempos extra.
    </li>
    <li>
        Las líneas para el 4o Cuarto NO incluyen tiempos extra.
    </li>
    <li>
        Resultado en pools dobles, consisten en el ganador del 1er tiempo y el
        ganador del partido.
    </li>
    <li>
        Los grupos de 1ra jugada de anotación y margen de victoria incluyen
        tiempo extra. Los grupos de resultados dobles NO incluye el tiempo extra
    </li>
    <li>
        2ndo Tiempo y cada Cuarto deben de completarse en su totalidad para que
        la apuesta sea válida.
    </li>
    <li>
        Las apuestas del Segundo Tiempo siempre incluyen tiempos extra
    </li>
</ul>
<h2>
    16.7 RUGBY (LEAGUE Y UNION)
</h2>
<p>
    A menos que se indique lo contrario, todas las apuestas de Rugby se
    califican en 80 minutos de juego, lo que incluye cualquier tiempo de
    detención, y no incluye tiempo adicional a menos que se especifique.
</p>
<p>
    Cuando se ofrece una opción de empate, la apuesta se califica al final de la
    regulación, no se incluye tiempo adicional.
</p>
<p>
    Si se cambia el lugar anunciado para el partido, todas las apuestas en ese
    partido se anularán.
</p>
<p>
    En el caso de cambio de oponente del que estaba anunciado, todas las
    apuestas para ese partido serán anuladas.
</p>
<p>
    <strong>Eventos Abandonados:</strong> Todas las apuestas se anulan aparte de
    los mercados en los que el resultado ya está determinado.
</p>
<p>
    <strong>Eventos pospuestos:</strong> son anulados a menos que se reorganicen
    y se jueguen en la misma Semana de Rugby (lunes a domingo, hora del Reino
    Unido incluida).
</p>
<p>
    El equipo local es el de arriba
</p>
<p>
    <strong>REGLAS AUSTRALIANAS</strong>
</p>
<p>
    <strong>Reglas Generales</strong>
</p>
<p>
    Todos los mercados de partidos se calificarán, incluida la prórroga si se
    juega, a menos que se indique lo contrario. El tiempo reglamentario debe
    completarse para que las apuestas sean válidas a menos que se indique lo
    contrario. Si la duración de un partido es cambiada por el organismo rector
    antes del comienzo del juego, la duración revisada del juego se considerará
    como el tiempo oficial de regulación para este partido, y todas las apuestas
    se mantendrán mientras se complete este nuevo tiempo reglamentario.
</p>
<p>
    <strong>Apuestas de Partido</strong> Si algún partido termina en empate,
    incluyendo la prórroga si se juega, las apuestas serán reembolsadas a menos
    que se ofrezca un precio para el empate. Las apuestas se calificarán solo en
    el resultado oficial de la AFL.
</p>
<p>
    <strong>Partidos Programados no Jugados</strong> Si se cambia el lugar del
    partido, las apuestas ya realizadas se mantendrán siempre que el equipo
    local siga siendo designado como tal. Si el equipo local y el equipo
    visitante de un partido de la lista se invierten, las apuestas realizadas en
    función del anuncio original se anularán.
</p>
<p>
    El equipo local es el de arriba
</p>
<h2>
    16.8 VOLLEYBALL
</h2>
<ul type="disc">
    <li>
        Si un partido se suspende antes de que se alcance el tiempo completo y
        no se completa el mismo día, las apuestas sobre el resultado del partido
        se considerarán canceladas y se reembolsarán todas las apuestas.
    </li>
    <li>
        Para las apuestas de partidos y sets, la cantidad real de puntos jugados
        en un set no afectará la calificación de las apuestas. Por ejemplo, los
        sets jugados a 21 o 25 puntos se califican según el ganador del set.
    </li>
    <li>
        En el caso de un formato de "Local y Visitante", las apuestas en el
        partido de Visitante no incluyen el "Set de Oro".
    </li>
</ul>
<h2>
    16.9 TENIS DE MESA
</h2>
<p>
    Partido válido: inicia al primer punto.
</p>
<p>
    Mercados: ganador, ganador de set, totales de puntos, handicap.
</p>
<p>
    Retiros: si ocurre después de iniciado, mercados no resueltos pueden ser
    Void según el mercado.
</p>
<p>
    Dada la alta frecuencia de live, TAR.LA puede aplicar delays y suspensiones
    más frecuentes.
</p>
<h2>
    16.10 CRICKET
</h2>
<p>
    <strong>Incluyendo Veinte/20 General:</strong>
</p>
<ul type="disc">
    <li>
        Todas las apuestas se liquidarán utilizando el resultado oficial
        declarado por el organismo rector correspondiente del partido o
        competición en cuestión.
    </li>
    <li>
        Cambio de lugar Si se cambia el lugar del partido, las apuestas ya
        realizadas se mantendrán siempre que el equipo local siga siendo
        designado como tal. Si el equipo local y el equipo visitante de un
        partido de la lista se invierten, las apuestas realizadas en función del
        anuncio original se anularán
    </li>
    <li>
        Si un partido se abandona debido a interferencias externas, las apuestas
        sobre el resultado para el total del partido se anularán, si no se
        declara ningún ganador desde el sitio oficial, todas las apuestas al
        ganador del partido se anularán.
    </li>
    <li>
        Si un partido se ve afectado por factores externos (como el mal tiempo),
        liquidaremos su apuesta en función de la regla oficial de la competición
        (esto incluye los partidos afectados por un cálculo matemático como el
        método Duckworth-Lewis (DL) o el sistema Jayadevan (VJD)*).* Método
        Duckworth Lewis / sistema Jayadevan. Estos son sistemas utilizados para
        ajustar las puntuaciones en caso de un retraso de lluvia durante los
        partidos de un día, con el fin de dejar el balance del partido
        inalterado. Los sistemas utilizan el número de ‘overs’ que cada equipo
        aún tiene que recibir y el número de ‘wickets’ que tienen en la mano
        para alcanzar un resultado oficial. 5.
    </li>
    <li>
        Cuando no se cotiza ningún precio para el empate y las reglas oficiales
        de la competencia no determinan un ganador, todas las apuestas se
        calificarán canceladas. En las competiciones en las que un bowl out o
        super over determina un ganador, las apuestas se establecerán en función
        del resultado oficial.
    </li>
</ul>
<p>
    <strong>Series:</strong>Si se empata una serie y no se ofreció ninguna
    opción de empate, todas las apuestas se considerarán como empate y se
    reembolsarán.
</p>
<p>
    <strong>Partidos de Prueba:</strong>
</p>
<ul type="disc">
    <li>
        En caso de que el juego no haya dado lugar al menos a 4 entradas, todas
        las apuestas sobre el resultado para los totales (altas / bajas) serán
        anuladas.
    </li>
    <li>
        En caso de que el juego no dure al menos 4 entradas, todas las apuestas
        sobre el resultado del ganador del partido se liquidan según el anuncio
        oficial.
    </li>
    <li>
        <strong>Prueba de coincidencia empatada:</strong>En el caso de un
        partido de prueba empatado (es decir, donde se hayan completado todas
        las entradas y ambos equipos tengan el mismo puntaje), todas las
        apuestas en el juego serán anuladas.
    </li>
    <li>
        Si se ofrece una línea de dinero de tres vías con el sorteo como tercera
        opción de apuesta, solo los apostadores que apostaron en el sorteo serán
        pagados como ganadores; Aquellos que apostaron a ganar a cualquiera de
        los equipos o concursantes perderán su apuesta.
    </li>
    <li>
        Si un partido de prueba es abandonado o interrumpido por interferencia
        externa (disturbios, etc.), todas las apuestas en este partido serán
        anuladas.
    </li>
</ul>
<p>
    <strong>Internacionales de un día:</strong>
</p>
<ul type="disc">
    <li>
        En caso de que el juego no haya superado al menos el número oficial de
        mayores, se anularán todas las apuestas sobre el resultado del mayor /
        menor.
    </li>
    <li>
        En caso de que el juego no haya tenido al menos el número oficial de
        mayores, todas las apuestas sobre el resultado del ganador del partido
        se liquidan según el anuncio oficial.
    </li>
    <li>
        En los partidos en los que se utiliza un día de reserva, todas las
        apuestas se mantendrán y se transferirán al día de reserva.
    </li>
</ul>
<p>
    <strong>Veinte / 20</strong>
</p>
<ul type="disc">
    <li>
        En caso de que el juego no haya tenido al menos el número oficial de
        overs, se anularán todas las apuestas sobre el resultado del over /
        under.
    </li>
    <li>
        En caso de que el juego no haya tenido al menos el número oficial de
        overs, todas las apuestas sobre el resultado del ganador del partido se
        liquidan según el anuncio oficial.
    </li>
</ul>
<p>
    <strong>REGLAS OLIMPICAS</strong>
</p>
<ul type="disc">
    <li>
        Para las apuestas de futuros de múltiples vías, todos los eventos son
        TODO ACCIÓN, sin reembolsos.
    </li>
    <li>
        Si un atleta / equipo en particular tiene un precio de sí / no
        (bidireccional) para ganar la medalla de oro, entonces ese atleta /
        equipo debe comenzar la competencia para la acción.
    </li>
    <li>
        Para las apuestas Match-Up entre dos atletas / 2 países en cualquier
        evento, ambos atletas / países deben comenzar el evento para la acción.
    </li>
    <li>
        Para más / menos en el total de medallas de un país dentro de un
        deporte, el total es para las competiciones masculinas y femeninas
        dentro de esa área – Ejemplo: si EE. UU. Gana 10 medallas en atletismo
        masculino y 9 en atletismo femenino, el total de medallas ganadas por
        EE. UU. tiene 19 años en Atletismo.
    </li>
    <li>
        Los eventos son oficiales después de la ceremonia de entrega de medallas
        original. Cualquier cambio posterior a esos resultados no cuenta.
    </li>
    <li>
        Para los accesorios de atletas individuales, el competidor debe comenzar
        el primer evento en el que están programados para participar para la
        acción.
    </li>
</ul>
<h2>
    16.11 FÓRMULA 1 (MOTORSPORT)
</h2>
<p>
    Ofreceremos QUINIELAS FUTURAS para carreras NASCAR, NATIONWIDE, INDY y F1.
    En estas QUINIELAS FUTURAS todas las apuestas se consideran VÁLIDAS incluso
    si el piloto no califica para la carrera principal.
</p>
<p>
    Después de las rondas clasificatorias, ofreceremos cuotas para ganar la
    carrera, terminar en el Top 3, Top 5 o Top 10, Sí/NO en esta posición final,
    Partidos de Carrera y Apuestas de Grupo. Para todo este tipo de apuestas el
    piloto DEBE comenzar en la carrera principal para que esta sea válida.
</p>
<p>
    En las Apuestas de Grupo si dos o más jugadores empatan por el mejor lugar
    en la Quiniela, los precios de las apuestas se dividirán por el número de
    los jugadores ganadores.
</p>
<p>
    Solo aceptamos Apuestas Directas en Carreras de Automovilísticas y las
    Proposiciones y Futuras de este. Cualquier otra apuesta como Combinada
    (Parlay), Condicionada, Reversa y/o Round Robin será cancelada por nosotros.
</p>
<p>
    Las descalificaciones posteriores a la carrera no afectarán o cambiarán el
    resultado de las apuestas.
</p>
<h2>
    16.12 GOLF
</h2>
<ul type="disc">
    <li>
        <strong>Para ganar el torneo:</strong>Los clientes apuestan a que uno de
        los jugadores sea el campeón del torneo.
    </li>
    <li>
        <strong>Para terminar en el Top 5:</strong>Los 5 primeros finalistas y
        cualquiera que empató con el quinto finalista.
    </li>
    <li>
        <strong>Para terminar en el Top 10:</strong>Los 10 mejores finalistas y
        cualquiera que empató con el décimo finalista.
    </li>
    <li>
        <strong>Emparejamientos</strong>: Emparejamos jugadores y el cliente
        elige uno de ellos para tener un mejor registro que el otro. Ofrecemos
        Emparejamientos para todo el torneo y en los principales eventos también
        ofrecemos apuestas para Emparejamientos de las Rondas.
    </li>
    <li>
        <strong>Apuestas de 3 Bolas:</strong>En juegos de 3 Ball Betting, 3
        golfistas se enfrentan y el golfista con la mejor puntuación gana el
        grupo. Las apuestas de 3 bolas se pueden ofrecer para todo el torneo o
        para una ronda específica. Si dos o más jugadores están empatados por la
        victoria en el grupo, se aplicará la regla de empate.
    </li>
    <li>
        <strong>Tiros de 6 Bolas:</strong>En juegos de 6 Ball Shooter, 6
        golfistas se enfrentan y el golfista con la mejor puntuación gana el
        grupo. Se puede ofrecer 6 Ball Shooter para todo el torneo o para la
        ronda específica. Si dos o más jugadores están empatados en la victoria,
        se aplicará la regla de empate.
    </li>
    <li>
        <strong>Jugador Principal en un grupo:</strong>En torneos importantes,
        ofrecemos grupos como el mejor jugador AMERICANO en el torneo. En tales
        piscinas, si se producen empates para la mejor posición, se aplicará la
        regla del calor muerto.
    </li>
    <li>
        <strong>Líder de ronda:</strong>En torneos importantes, ofrecemos un
        grupo para el mejor puntaje en una ronda de juego específica. En dichos
        grupos, si se producen empates para obtener la mejor puntuación, se
        aplicará la regla del calor muerto.
    </li>
</ul>
<p>
    <strong>Regla Dead Heat</strong>
</p>
<p>
    Para las apuestas de golf que contiene más de dos participantes, tales como
    3 Bolas, 6 Shooter Ball mejores jugadores en un grupo y el líder de Ronda
    (S), por ejemplo, que dos o más jugadores empatan en el mismo lugar se
    aplica la regla de empate de la siguiente manera: La apuesta se reduce de
    acuerdo con la cantidad de jugadores que empatan y luego se aplica a las
    cuotas completas con el resto de la apuesta considerada como perdida.
</p>
<p>
    Por ejemplo:
</p>
<ul type="disc">
    <li>
        Apuesta $ 150 con una probabilidad de +200 y 2 jugadores empatan en la
        misma posición. Se pierde la mitad de la apuesta: $ 75, la otra mitad
        gana y se le pagan las mismas probabilidades. Entonces $ 75 gana a +200
        = $ 150 – $ 75 = $ 75 netos.
    </li>
    <li>
        Si 3 jugadores empatan en la misma posición, entonces: dos tercios de la
        apuesta se pierden – $ 100, los terceros $50 restantes ganan a +200.
    </li>
</ul>
<p>
    Tenga en cuenta que esta regla no se aplica a los enfrentamientos de dos
    jugadores donde un empate resulta en un empate.
</p>
<p>
    Para los Emparejamientos, el jugador debe dar el primer golpe para
    considerarse válido. Si un jugador no da el primer golpe, entonces cualquier
    apuesta que lo involucre se considerará inválida y será cancelada. La
    excepción a esta regla es cuando la apuesta se realiza en una quiniela y
    todos los jugadores tienen acción independientemente de si comienzan o no el
    torneo. (por ejemplo: para ganar EL TORNEO)
</p>
<p>
    Si un jugador se da un primer golpe, es válido independientemente del número
    de hoyos jugados.
</p>
<table border="0" cellpadding="0">
    <tbody>
        <tr>
            <td width="311">
                <p>
                    Fred Funk
                </p>
            </td>
            <td width="311">
                <p>
                    - 125
                </p>
            </td>
        </tr>
        <tr>
            <td width="311">
                <p>
                    Joe Durant
                </p>
            </td>
            <td width="311">
                <p>
                    +105
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p>
    En este torneo, si el cliente elige Fred Funk, la apuesta está en Fred Funk
    para tener un mejor registro que Joe Durant. No necesariamente que Funk debe
    ganar el campeonato, sino que va a terminar en una mejor posición que
    Durant.
</p>
<p>
    Ambos jugadores deben pegarle a la bola en el torneo para que la apuesta sea
    válida. En una apuesta de dos jugadores, el jugador que complete más hoyos
    será declarado ganador. Si ambos jugadores completan el mismo número de
    hoyos, la puntuación más baja gana.
</p>
<p>
    <strong>Rondas Específicas:</strong> Aparte de las probabilidades de ganar
    todo el Torneo, también podemos ofrecer cuotas para ganar una Ronda
    Específica. Así que un cliente puede apostar a un jugador para ganar la 3a
    ronda solamente. Si este es el caso, especificaremos que la apuesta es solo
    para la ronda y no para todo el torneo. Ambos jugadores deben salir en la
    ronda especificada para que la apuesta sea válida. La 4a ronda no incluye
    juegos post-temporada
</p>
<p>
    Cuando se utiliza un método de puntuación de puntos como Stableford, el
    número más alto de puntos gana. La única excepción a esta regla es cuando un
    torneo se acorta por lluvia y las puntuaciones finales son determinadas por
    la PGA por lo general volviendo a la última ronda completada.
</p>
<p>
    SOLO aceptamos Apuestas Directas para Golf, independientemente de si se
    trata de una apuesta en Para Ganar Torneos, Top 5, Top 10, Emparejamientos
    de Torneo, Emparejamientos de Rondas o Apuestas de Jugador Principal o
    Líder. Cualquier otro tipo de apuesta que no sea una Apuesta Directa
    (Ejemplo: Combinadas (Parlays), Condicionadas, Reversas y/o Round Robins)
    será cancelada por nosotros sin previo aviso.
</p>
<h2>
    16.13 BOXEO / MMA
</h2>
<ul type="disc">
    <li>
        <strong>Para Ganar la Pelea:</strong>Elegir el luchador que el cliente
        cree que ganará la pelea. Los empates cancelarán estas apuestas.
    </li>
    <li>
        <strong>Total de Rondas:</strong>El cliente apuesta las Altas o Bajas
        sobre el número de rondas en las que se terminará la pelea.
    </li>
    <li>
        <strong>Apuestas de Resultado Correcto:</strong>Los jugadores pueden
        apostar en qué boxeador ganará la pelea y la forma en que se gana la
        pelea. Un NOCAUT (KNOCKOUT) incluye Nocauts Técnicos (TKO) y
        Descalificaciones (DQ). Se determina que una DECISIÓN es cada vez que se
        utilizan los cuadros de mando del juez para determinar el ganador de la
        pelea, independientemente de la ronda en la que esto ocurra. EMPATE
        (DRAW) es una opción de apuesta y si se produce un EMPATE, las otras
        apuestas de Resultado Correcto serán perdedoras.
    </li>
</ul>
<p>
    Digamos que la línea en las rondas en una pelea es de 4.5 (3 minutos). Si un
    jugador apuesta en las Altas, está diciendo que la pelea durará más de 4.5
    rondas. Eso sería 4 rondas completas y los primeros 1.5 minutos en la 5a
    ronda (1 minuto y 30 segundos).
</p>
<h2>
    16.14 ESPORTS
</h2>
<ul type="disc">
    <li>
        Las fechas y horas de inicio que se muestran en nuestro sitio web para
        los partidos de E-Sport son solo una indicación y no se garantiza que
        sean correctas. Si un partido se suspende o pospone, y no se reanuda
        dentro de las 12 horas posteriores a la hora de inicio real programada,
        las apuestas en el partido no tendrán efecto y serán reembolsadas. Con
        la excepción de cualquier apuesta sobre si un equipo/jugador avanza en
        un torneo o gana el torneo, tendrá acción independientemente de un
        partido suspendido o pospuesto.
    </li>
    <li>
        Si el nombre de un jugador/equipo está mal escrito, todas las apuestas
        se mantendrán a menos que sea obvio que es el objeto incorrecto.
    </li>
    <li>
        Si en un partido oficial un jugador juega con un apodo incorrecto o con
        una cuenta de pitufo, el resultado sigue siendo válido a menos que sea
        evidente que no es el jugador que se suponía que jugaría ese partido.
    </li>
    <li>
        Todas las apuestas se liquidarán utilizando el resultado oficial
        declarado por el organismo rector pertinente de la competición en
        cuestión.
    </li>
    <li>
        Si no se ha habilitado una opción de empate, se contará el tiempo extra,
        si se juega.
    </li>
    <li>
        Apuestas con hándicap: un margen en E-Sports puede ser Rondas/Mapas u
        otras medidas de conteo dependiendo del juego. El diferencial solo se
        denominará diferencial. (Por ejemplo, en Counter Strike la distribución
        serán rondas ganadas, mientras que en Starcraft 2 la distribución serán
        mapas).
    </li>
</ul>
<p>
    El hándicap es una forma de hacer que una competición deportiva sea más
    igualada y, por tanto, más interesante como objeto de apuesta. En las
    apuestas de deportes electrónicos, esto se hace otorgando a uno de los
    equipos/jugadores, el perdedor, algunos mapas/rondas por delante.
</p>
<p>
    Por ejemplo:
</p>
<table border="0" cellpadding="0">
    <tbody>
        <tr>
            <td width="207">
            </td>
            <td width="207">
                <p>
                    Handicap
                </p>
            </td>
            <td width="207">
                <p>
                    Probabilidad
                </p>
            </td>
        </tr>
        <tr>
            <td width="207">
                <p>
                    Juegador A
                </p>
            </td>
            <td width="207">
                <p>
                    -1.5
                </p>
            </td>
            <td width="207">
                <p>
                    2.00
                </p>
            </td>
        </tr>
        <tr>
            <td width="207">
                <p>
                    Jugador B
                </p>
            </td>
            <td width="207">
                <p>
                    +1.5
                </p>
            </td>
            <td width="207">
                <p>
                    1.85
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p>
    Si el jugador A gana el partido por dos mapas o más, los apostadores del
    jugador A ganan y los del jugador B pierden. Si el jugador A gana por
    exactamente un mapa o el jugador B gana, los apostadores del jugador B ganan
    y los apostadores del jugador A pierden.
</p>
<ul type="disc">
    <li>
        Apuestas Totales: Un total en E-sports puede ser Rondas/Mapas u otras
        medidas de conteo dependiendo del juego. El total solo se denominará
        total.
    </li>
</ul>
<p>
    Ejemplo de un partido SC2 al mejor de tres:
</p>
<table border="0" cellpadding="0">
    <tbody>
        <tr>
            <td width="207">
                <p>
                    Arriba
                </p>
            </td>
            <td width="207">
                <p>
                    2.5
                </p>
            </td>
            <td width="207">
                <p>
                    1.93
                </p>
            </td>
        </tr>
        <tr>
            <td width="207">
                <p>
                    Abajo
                </p>
            </td>
            <td width="207">
                <p>
                    2.5
                </p>
            </td>
            <td width="207">
                <p>
                    1.93
                </p>
            </td>
        </tr>
    </tbody>
</table>
<ul type="disc">
    <li>
        Si cualquiera de los jugadores gana 2-0, todas las apuestas por menos de
        2,5 ganarán, mientras que las apuestas por más perderán. Si cualquiera
        de los jugadores gana 2-1, todas las apuestas al más ganan, mientras que
        las apuestas al menos pierden.
    </li>
    <li>
        Si un mapa no se completa debido a la retirada o descalificación de un
        jugador, todas las apuestas sobre el resultado tendrán acción y se
        validarán en función del ganador oficial declarado. Los mapas de
        Counter-Strike son excepciones a esta regla, por lo que todas las
        apuestas de línea de dinero, margen y total se cancelan si un equipo se
        retira o es descalificado antes de que se jueguen todas las rondas de
        mapa programadas.
    </li>
    <li>
        Si se cambia el número anunciado de mapas/rondas, se cancelan todas las
        apuestas sobre el hándicap o el total. Las apuestas en la línea de
        dinero (resultado del partido) tienen acción.
    </li>
    <li>
        Si un jugador o equipo recibe un walkover o gana por decisión del
        administrador en al menos un mapa, todas las apuestas en la serie (línea
        de dinero, margen y total) se cancelarán y se reembolsará el dinero. En
        CS: GO, si un equipo se retira o es descalificado antes de que se
        jueguen todas las rondas programadas en un mapa, todas las apuestas en
        la serie (líneas de dinero, margen y total) se cancelarán y también se
        reembolsará el dinero.
    </li>
</ul>
<h2>
    16.15 DARDOS
</h2>
<p>
    Mercados: ganador, sets/legs, handicap, totales.
</p>
<p>
    Si un jugador se retira, mercados no resueltos pueden ser Void según el
    mercado.
</p>
<p>
    Dead heat normalmente no aplica, salvo mercados de posiciones.
</p>
<h2>
    16.16 AJEDREZ
</h2>
<p>
    Mercados: ganador del match/serie, empate (si aplica), totales de partidas
    (si el mercado lo ofrece).
</p>
<p>
    Resultados: se liquidan con base en el resultado oficial del organizador.
</p>
<p>
    Si el match es reprogramado, aplica regla de 25 horas cuando corresponda al
    evento ofertado (si el mercado se considera el mismo evento).
</p>
<h2>
    16.17 WATER POLO
</h2>
<ul type="disc">
    <li>
        <strong>Líneas de dinero:</strong>a menos que se indique lo contrario,
        todas las apuestas son únicamente para el tiempo reglamentario y no
        incluyen tiempos extra ni tiros de penales.
    </li>
    <li>
        <strong>El ganador del 1er, 2nd, 3er y 4to cuarto:</strong>únicamente
        los goles anotados durante el tiempo nominado para el periodo cuentan. A
        menos que se indique lo contrario, los goles anotados en tiempo extra NO
        cuentan como parte del 4to periodo.
    </li>
</ul>
<p>
    En el caso de un formato de "Local y Visitante", las apuestas en el partido
    de Visitante no incluyen el "Set de Oro".
</p>
<h2>
    16.18 OTROS DEPORTES (BALONMANO, FUTSAL, WATERPOLO, BIATLÓN, CURLING, BANDY,
    LACROSSE, SQUASH, FLOORBALL)
</h2>
<p>
    Para estos deportes, salvo que el mercado indique una regla específica:
</p>
<p>
    (a) Las apuestas se liquidan por resultados oficiales del organizador.
</p>
<p>
    (b) Tiempo aplicable: tiempo reglamentario del deporte correspondiente.
</p>
<p>
    (c) Si el evento se abandona sin resultado oficial, mercados no resueltos se
    declaran Void.
</p>
<p>
    (d) Mercados por periodos requieren completar el periodo para liquidar no
    resueltos.
</p>
<h1>
    17. DISPUTAS, AUDITORÍA Y CANAL DE RECLAMOS
</h1>
<p>
    17.1 El Jugador podrá presentar reclamos a través de los canales oficiales
    indicados en los Términos y Condiciones.
</p>
<p>
    17.2 TAR.LA revisará: ticket, hora de aceptación, estado del mercado, feed
    de datos, y resultados/estadísticas oficiales.
</p>
<p>
    17.3 TAR.LA podrá corregir liquidaciones si se detecta error, conservando
    evidencia del ajuste.
</p>
<h1>
    18. MODIFICACIÓN DE REGLAS Y VIGENCIA
</h1>
<p>
    TAR.LA podrá actualizar estas reglas para reflejar cambios del sistema,
    mercados, deportes o proveedores. La versión vigente será la publicada en
    https://tar.la/ al momento de la apuesta.
</p>
<br clear="all"/>
<h1>
    ANEXO A – EJEMPLOS PRÁCTICOS DE LIQUIDACIÓN
</h1>
<ul>
    <li>
        Ejemplo A1 (Parlay con selección Void): 3 selecciones; 1 se declara Void
        → esa selección se trata como cuota 1.00 y el parlay se recalcula con
        las restantes.
    </li>
    <li>
        Ejemplo A2 (Asian Handicap -0.25): Stake se divide. Empate → mitad Push
        (devuelta) y mitad pérdida.
    </li>
    <li>
        Ejemplo A3 (Total 2.0): Marcador final = 2 → Push (stake devuelto).
    </li>
    <li>
        Ejemplo A4 (Bet Builder): Si una selección se vuelve inválida y el
        sistema permite recalcular, se ajusta cuota total; si no, el ticket
        puede ser Void.
    </li>
    <li>
        Ejemplo A5 (Live fuera de tiempo): Apuesta aceptada después de gol →
        puede declararse Void por integridad.
    </li>
</ul>
<h1>
    ANEXO B – GLOSARIO AMPLIADO
</h1>
<ul>
    <li>
        Dead Heat: empates en posiciones (top 5/10/podio). El retorno se
        prorratea.
    </li>
    <li>
        Half Win / Half Loss: resultado de líneas asiáticas fraccionadas por
        división del stake.
    </li>
    <li>
        Listed Pitcher: condición de béisbol donde el pitcher inicial afecta la
        validez del mercado.
    </li>
    <li>
        Puck Line: hándicap estándar en hockey.
    </li>
    <li>
        DLS: método oficial en cricket para partidos afectados por lluvia.
    </li>
    <li>
        SGP/Bet Builder: combinación de selecciones dentro del mismo evento.
    </li>
</ul>
<h1>
    ANEXO C – BUENAS PRÁCTICAS PARA EL JUGADOR
</h1>
<ul>
    <li>
        Revise el mercado y el periodo (partido, 1er tiempo, 1er cuarto) antes
        de confirmar.
    </li>
    <li>
        En apuestas en vivo, considere que existe latencia y el mercado puede
        suspenderse.
    </li>
    <li>
        Verifique reglas de prórroga/OT/penales según el mercado.
    </li>
    <li>
        En mercados multiway, considere la regla de Dead Heat para empates en
        posiciones.
    </li>
    <li>
        Para props, confirme si el jugador debe iniciar/participar o si el
        mercado es 'acción'.
    </li>
</ul>

<br><br>
<p align="center">
    <strong>
        TÉRMINOS Y CONDICIONES – PAGO ANTICIPADO (EARLY PAYOUT) – TAR.LA (SOLO
        PRE-MATCH)
    </strong>
</p>
<p>
    <strong>1. Disposiciones Generales</strong>
</p>
<p>
    La funcionalidad Pago Anticipado (Early Payout) es una promoción especial
    ofrecida por TAR.LA que permite la liquidación anticipada de determinadas
    apuestas deportivas pre-match elegibles antes de la finalización oficial del
    evento correspondiente, siempre que se cumplan las condiciones específicas
    establecidas en estos Términos y Condiciones.
</p>
<p>
    El Pago Anticipado aplica únicamente a selecciones, mercados, eventos,
    deportes, tipos de apuesta, clientes, jurisdicciones, ligas, torneos y
    competiciones expresamente habilitados por TAR.LA y/o por su proveedor de
    sistema. Su disponibilidad podrá variar según el deporte, liga, torneo,
    proveedor, tipo de cliente, jurisdicción, ventanas de mantenimiento,
    limitaciones operativas, criterios de riesgo, controles antifraude o
    cualquier otra consideración comercial u operativa determinada por TAR.LA.
</p>
<p>
    Para evitar cualquier duda, la funcionalidad de Pago Anticipado regulada por
    estos Términos y Condiciones aplica exclusivamente a apuestas PRE-MATCH. No
    aplica a apuestas live / in-play bajo ninguna circunstancia, salvo que
    TAR.LA publique expresamente términos y condiciones separados que indiquen
    lo contrario.
</p>
<p>
    La participación en esta funcionalidad implica la aceptación íntegra de los
    presentes Términos y Condiciones, conjuntamente con los Términos y
    Condiciones Generales de TAR.LA, las Reglas Oficiales de Apuestas Deportivas
    y cualquier otra normativa complementaria aplicable al deporte, mercado,
    liga, competición o promoción correspondiente.
</p>
<p>
    <strong>2. Definición del Pago Anticipado</strong>
</p>
<p>
    El Pago Anticipado (Early Payout) consiste en la liquidación automática
    anticipada de una selección pre-match elegible como apuesta ganadora cuando
    el equipo o participante seleccionado alcanza el umbral de ventaja aplicable
    durante el desarrollo del evento, sin necesidad de esperar a la finalización
    oficial del mismo.
</p>
<p>
    Una vez activado válidamente y acreditado el Pago Anticipado, la selección
    correspondiente será considerada como selección ganadora para efectos de
    liquidación conforme a estos Términos y Condiciones, aun cuando el resultado
    final oficial del evento sea distinto, salvo en los supuestos expresamente
    excluidos, sujetos a corrección, o afectados por anulación, cancelación,
    error técnico, error manifiesto o revisión antifraude conforme a estas
    reglas o a las reglas generales de TAR.LA.
</p>
<p>
    <strong>3. Elegibilidad General</strong>
</p>
<p>
    Salvo indicación expresa en contrario por parte de TAR.LA, el Pago
    Anticipado solo aplicará cuando se cumplan todas las siguientes condiciones.
</p>
<p>
    3.1 Tipo de apuesta <br/>
    La funcionalidad podrá aplicar únicamente a apuestas Simples y Múltiples
    (Parlays). En las apuestas múltiples, cada selección individual deberá
    cumplir de forma independiente con los requisitos de elegibilidad aplicables
    al Pago Anticipado. <br/>
    El Pago Anticipado NO aplica a apuestas de tipo Sistema (System Bets), Bet
    Builder, Same Game Parlay, productos de combinación personalizada, ni a
    cualquier otra estructura de apuesta no habilitada expresamente por TAR.LA.
</p>
<p>
    3.2 Momento de colocación <br/>
    La apuesta deberá ser realizada antes del inicio oficial del evento
    correspondiente (pre-match). Las apuestas realizadas después del inicio
    oficial del evento, incluyendo apuestas live / in-play, no serán elegibles
    para Pago Anticipado bajo estos Términos y Condiciones.
</p>
<p>
    3.3 Mercado elegible <br/>
    La apuesta deberá haberse realizado exclusivamente en el mercado principal
    de ganador del evento, según el deporte correspondiente y conforme a las
    reglas específicas de la Sección 10.
</p>
<p>
    3.4 Evento habilitado <br/>
    El evento deberá estar expresamente habilitado por TAR.LA y/o por el
    proveedor del sistema para la funcionalidad Pago Anticipado. La mera
    existencia de un mercado elegible no garantiza que el evento esté incluido
    en la promoción.
</p>
<p>
    3.5 Ligas y Competiciones Elegibles <br/>
    El evento correspondiente deberá pertenecer a una liga, torneo o competición
    habilitada por TAR.LA para esta funcionalidad, de conformidad con la Sección
    14 siguiente, sujeto siempre a la configuración activa del sistema y a la
    habilitación del proveedor.
</p>
<p>
    <strong>4. Exclusiones Generales</strong>
</p>
<p>
    Salvo indicación expresa en contrario, el Pago Anticipado NO aplicará a:
    apuestas live / in-play; mercados distintos al mercado principal de ganador
    elegible; selecciones de empate cuando aplique; mercados alternativos,
    especiales, derivados, parciales o no expresamente incluidos; apuestas de
    tipo Sistema (System Bets); apuestas Bet Builder; Same Game Parlays;
    apuestas sobre tiempos parciales, mitades, cuartos, períodos, entradas
    parciales, sets individuales, mercados por set, mercados por game, score
    exacto, props, handicaps, spreads, totals / over-under, team totals, doble
    oportunidad, draw no bet, clasificación, tiempo extra, penales, shootouts, o
    cualquier otro mercado distinto al mercado principal expresamente
    habilitado; apuestas ya liquidadas, anuladas, reembolsadas, objeto de Cash
    Out total o declaradas void; eventos virtuales, simulados, eSports,
    amistosos no oficiales, competiciones no profesionales, juveniles, equipos
    de reserva, exhibiciones o cualquier otra categoría excluida por TAR.LA; y
    apuestas afectadas total o parcialmente por errores técnicos, errores de
    feed, errores de integración, errores del proveedor, errores evidentes o
    manifiestos, o cualquier otro supuesto previsto en estos Términos y
    Condiciones.
</p>
<p>
    <strong>5. Reglas de Liquidación del Pago Anticipado</strong>
</p>
<p>
    Cuando una selección pre-match elegible alcance el umbral de ventaja
    establecido para su deporte, conforme a las reglas específicas de la Sección
    10, la apuesta podrá ser liquidada anticipadamente como apuesta ganadora.
</p>
<p>
    5.1 Momento de acreditación <br/>
    Las ganancias serán acreditadas tan pronto como sea razonablemente posible,
    sujeto a validación del proveedor oficial de datos, confirmación del
    sistema, controles automáticos o manuales de riesgo, estabilidad operativa
    del feed, controles antifraude y cualquier revisión técnica u operativa
    necesaria. TAR.LA no garantiza acreditación instantánea o inmediata en
    tiempo real.
</p>
<p>
    5.2 Carácter definitivo condicionado <br/>
    Una vez acreditado el Pago Anticipado, la selección será tratada como
    selección ganadora para fines de liquidación, salvo que posteriormente se
    detecte algún error técnico, error de sistema, error de integración, error
    del proveedor, discrepancia de datos, activación indebida, evento no
    elegible, mercado incorrecto, liga o competición no elegible, cancelación
    oficial del evento, liquidación void, pago duplicado, error evidente o
    manifiesto, actividad sospechosa, uso abusivo, actividad fraudulenta o
    irregular, o cualquier otra causa prevista en estos Términos y Condiciones o
    en las reglas generales de TAR.LA.
</p>
<p>
    <strong>6. Reglas sobre Apuestas Múltiples</strong>
</p>
<p>
    En apuestas múltiples (Parlays), cuando una selección elegible active
    válidamente el Pago Anticipado, dicha selección será considerada como
    selección ganadora a su cuota original para efectos del cálculo de la
    apuesta múltiple, aun cuando el resultado final del evento sea distinto. Las
    demás selecciones del ticket continuarán sujetas a sus reglas normales de
    liquidación.
</p>
<p>
    Cada selección de una apuesta múltiple debe calificar de forma
    independiente. El Pago Anticipado en una selección no altera la elegibilidad
    ni las reglas de liquidación de las demás selecciones del ticket.
</p>
<p>
    <strong>7. Reglas sobre Cash Out</strong>
</p>
<p>
    7.1 Cash Out total: El Pago Anticipado NO aplicará a apuestas que hayan sido
    objeto de Cash Out total antes de que el umbral correspondiente sea
    válidamente activado.
</p>
<p>
    7.2 Cash Out parcial: Cuando una apuesta haya sido objeto de Cash Out
    parcial y posteriormente la selección elegible active válidamente el Pago
    Anticipado, la liquidación se realizará únicamente sobre la porción activa
    restante de la apuesta.
</p>
<p>
    7.3 Sin doble beneficio: Si una selección ya fue liquidada mediante Pago
    Anticipado, no generará una segunda liquidación basada en el resultado final
    oficial del evento.
</p>
<p>
    <strong>8. Datos Oficiales, Errores y Derecho de Corrección</strong>
</p>
<p>
    8.1 Fuente Oficial de Datos <br/>
    La activación y liquidación del Pago Anticipado se determinarán
    exclusivamente con base en los datos oficiales del evento y/o en proveedores
    de datos autorizados por TAR.LA. Los marcadores, estadísticas, relojes,
    indicadores u otra información visible en la interfaz del usuario pueden
    presentar retrasos, latencia, problemas de sincronización, errores
    temporales o diferencias de visualización. En caso de discrepancia,
    prevalecerán los datos oficiales utilizados por TAR.LA para la liquidación.
</p>
<p>
    8.2 Error Evidente / Error Manifiesto <br/>
    TAR.LA se reserva el derecho de corregir, anular, revertir, ajustar,
    recalcular o reliquidar cualquier Pago Anticipado acreditado por error,
    incluyendo sin limitación supuestos de error técnico, error de sistema,
    error de integración, error del proveedor de datos, activación indebida,
    liquidación sobre un evento, liga, competición o mercado no elegible, pago
    duplicado, error de visualización, error evidente o manifiesto, o cualquier
    otra circunstancia que resulte en una liquidación incorrecta.
</p>
<p>
    <strong>9. Suspensiones, Cancelaciones, Eventos Void y Antifraude</strong>
</p>
<p>
    9.1 Eventos Void o Cancelados <br/>
    Si un evento, selección o mercado es cancelado, suspendido, abandonado,
    pospuesto, interrumpido, reprogramado o declarado void de conformidad con
    los Términos y Condiciones Generales o las Reglas Oficiales de Apuestas
    Deportivas de TAR.LA, el Pago Anticipado podrá no aplicar, ser suspendido,
    ser revertido o ser reliquidado, según corresponda conforme a las reglas del
    deporte y mercado afectados.
</p>
<p>
    9.2 Actividad Irregular / Uso Abusivo <br/>
    TAR.LA se reserva el derecho de limitar, excluir, suspender, anular,
    revertir o denegar el acceso a la funcionalidad Pago Anticipado en casos de
    multi-cuentas, colusión, arbitraje entre operadores, manipulación de
    mercados, patrones de explotación abusiva, uso de bots, scripts,
    automatización, uso irregular de promociones, patrones de apuesta
    sospechosos, o cualquier conducta que, a criterio razonable de TAR.LA,
    constituya un uso indebido de esta funcionalidad.
</p>
<p>
    <strong>10. Reglas Específicas por Deporte</strong>
</p>
<p>
    Las siguientes reglas específicas aplican únicamente a los mercados
    principales de ganador expresamente habilitados por TAR.LA y exclusivamente
    a apuestas PRE-MATCH.
</p>
<p>
    10.1 Fútbol <br/>
    Aplica a apuestas elegibles pre-match realizadas en el mercado 1X2 regular
    (solo ganador local o ganador visitante). No aplica a la selección empate ni
    a ningún otro mercado. Condición de activación: Si el equipo seleccionado
    obtiene una ventaja de 2 goles en cualquier momento del tiempo
    reglamentario, la apuesta será elegible para Pago Anticipado.
</p>
<p>
    10.2 Béisbol <br/>
    Aplica a apuestas elegibles pre-match realizadas únicamente en el mercado
    principal de Ganador / Moneyline del juego completo. Condición de
    activación: Si el equipo seleccionado obtiene una ventaja de 5 carreras
    (runs) en cualquier momento del juego, la apuesta será elegible para Pago
    Anticipado.
</p>
<p>
    10.3 Fútbol Americano <br/>
    Aplica a apuestas elegibles pre-match realizadas únicamente en el mercado
    principal Moneyline del partido completo. Condición de activación: Si el
    equipo seleccionado obtiene una ventaja de 17 puntos en cualquier momento
    del partido, la apuesta será elegible para Pago Anticipado.
</p>
<p>
    10.4 Baloncesto <br/>
    Aplica a apuestas elegibles pre-match realizadas únicamente en el mercado
    principal Moneyline del partido completo. Condición de activación: Si el
    equipo seleccionado obtiene una ventaja de 18 puntos en cualquier momento
    del partido, la apuesta será elegible para Pago Anticipado.
</p>
<p>
    10.5 Hockey sobre Hielo <br/>
    Aplica a apuestas elegibles pre-match realizadas únicamente en el mercado
    principal Moneyline del partido completo habilitado por TAR.LA. Condición de
    activación: Si el equipo seleccionado obtiene una ventaja de 3 goles en
    cualquier momento del partido, la apuesta será elegible para Pago
    Anticipado.
</p>
<p>
    10.6 Tennis / Tenis <br/>
    Aplica a apuestas elegibles pre-match realizadas exclusivamente en el
    mercado principal de ganador del partido completo (Match Winner / Winner)
    únicamente. No aplica a mercados de ganador de set, ganador de game,
    apuestas por set, score exacto, handicaps, totals / over-under, props de
    jugador ni a ningún otro mercado derivado o parcial. <br/>
    Condición de activación: Si el jugador seleccionado alcanza la ventaja
    configurada calificada de 2 sets durante el partido, la apuesta podrá ser
    elegible para Pago Anticipado, sujeto en todo momento a la configuración
    activa del proveedor, validación del sistema, formato del evento y
    confirmación final de TAR.LA. <br/>
    Para evitar dudas, TAR.LA podrá restringir, deshabilitar o no aplicar el
    Pago Anticipado en eventos de tenis cuando el formato del partido, la
    configuración del proveedor, la estructura del mercado o la lógica operativa
    no permitan soportar el umbral configurado. La disponibilidad mostrada en la
    plataforma al momento de la apuesta prevalecerá.
</p>
<p>
    <strong>11. Disponibilidad, Modificación y Terminación</strong>
</p>
<p>
    TAR.LA se reserva el derecho, en cualquier momento y sin necesidad de previo
    aviso, de habilitar o deshabilitar el Pago Anticipado para uno o más
    deportes, ligas, torneos, competiciones, mercados o clientes; modificar los
    umbrales de activación; excluir eventos o competiciones; suspender
    temporalmente la funcionalidad por razones técnicas, operativas,
    comerciales, regulatorias o de riesgo; modificar, actualizar o reemplazar
    estos Términos y Condiciones; o cancelar la promoción total o parcialmente.
    Cualquier modificación surtirá efectos desde su publicación en el sitio web
    o desde su implementación en el sistema, según corresponda.
</p>
<p>
    <strong>12. Relación con Otras Reglas de TAR.LA</strong>
</p>
<p>
    Estos Términos y Condiciones deben interpretarse conjuntamente con los
    Términos y Condiciones Generales de TAR.LA, las Reglas Oficiales de Apuestas
    Deportivas, las reglas específicas de cada deporte o mercado, y las reglas
    aplicables sobre límites, clasificación de clientes, restricciones
    promocionales y políticas antifraude. En caso de conflicto, TAR.LA
    determinará la interpretación aplicable según las circunstancias concretas,
    la lógica del proveedor y las reglas internas vigentes.
</p>
<p>
    <strong>13. Disposición Final</strong>
</p>
<p>
    La participación en la funcionalidad Pago Anticipado (Early Payout)
    constituye aceptación plena de estos Términos y Condiciones. TAR.LA se
    reserva la interpretación final y la facultad de resolver cualquier
    situación no prevista expresamente en este documento.
</p>
<p>
    En caso de discrepancia entre mensajes promocionales, banners, etiquetas de
    interfaz o comunicaciones de marketing y estos Términos y Condiciones,
    prevalecerán estos Términos y Condiciones en la máxima medida permitida por
    la ley aplicable.
</p>
<p>
    <strong>14. Ligas y Competiciones Elegibles para Pago Anticipado</strong>
</p>
<p>
    El Pago Anticipado (Early Payout) podrá estar disponible únicamente en
    determinadas ligas, torneos o competiciones expresamente habilitadas por
    TAR.LA y/o por el proveedor del sistema para esta funcionalidad.
</p>
<p>
    La inclusión de una liga o competición dentro de la siguiente lista no
    garantiza que todos sus eventos, mercados, selecciones o modalidades de
    apuesta estén siempre disponibles para Pago Anticipado. La elegibilidad
    final dependerá, en cada caso, de la configuración activa del sistema, de la
    habilitación del proveedor, del tipo de mercado, de la jurisdicción
    aplicable, de restricciones operativas, de criterios de riesgo, de controles
    antifraude y de cualquier otra condición comercial u operativa determinada
    por TAR.LA.
</p>
<p>
    TAR.LA se reserva el derecho de agregar, remover, suspender, limitar o
    modificar en cualquier momento, y sin previo aviso, cualquier liga, torneo,
    competición, evento o mercado elegible para la funcionalidad Pago
    Anticipado.
</p>
<p>
    La lista siguiente tiene carácter referencial y refleja las ligas estándar
    actualmente configuradas para Pago Anticipado según la configuración vigente
    del operador. La disponibilidad real del Pago Anticipado en un evento
    específico prevalecerá exclusivamente según la habilitación visible en la
    plataforma al momento de la apuesta y conforme a la lógica operativa del
    proveedor.
</p>
<p>
    <strong>14.1 Fútbol</strong>
</p>
<ul>
    <li>
        UEFA Champions League
    </li>
    <li>
        UEFA Europa League
    </li>
    <li>
        UEFA Conference League
    </li>
    <li>
        Bundesliga de Alemania
    </li>
    <li>
        Ligue 1 de Francia
    </li>
    <li>
        Premier League de Inglaterra
    </li>
    <li>
        LaLiga de España
    </li>
    <li>
        Serie A de Italia
    </li>
    <li>
        Eredivisie de Países Bajos
    </li>
    <li>
        Primeira Liga de Portugal
    </li>
    <li>
        Major League Soccer (MLS)
    </li>
    <li>
        Primera División de Argentina
    </li>
    <li>
        Copa Libertadores
    </li>
    <li>
        Liga MX de México
    </li>
</ul>
<p>
    <strong>14.2 Baloncesto</strong>
</p>
<ul>
    <li>
        NBA - Temporada Regular
    </li>
    <li>
        NBA - Play-In
    </li>
    <li>
        NBA - Playoffs
    </li>
    <li>
        Juegos Olímpicos Masculinos de Baloncesto
    </li>
    <li>
        Juegos Olímpicos Femeninos de Baloncesto
    </li>
    <li>
        Copa Mundial de Baloncesto FIBA
    </li>
</ul>
<p>
    <strong>14.3 Tenis</strong>
</p>
<ul>
    <li>
        Wimbledon Masculino (ATP)
    </li>
    <li>
        Wimbledon Femenino (WTA)
    </li>
    <li>
        Abierto de Australia Masculino (ATP)
    </li>
    <li>
        Roland Garros Masculino (ATP)
    </li>
    <li>
        US Open Masculino (ATP)
    </li>
    <li>
        ATP Finals
    </li>
    <li>
        Masters 1000 de Indian Wells (ATP)
    </li>
    <li>
        Masters 1000 de Montecarlo (ATP)
    </li>
    <li>
        Masters 1000 de Roma (ATP)
    </li>
    <li>
        Cincinnati Masters ABD (ATP Masters 1000)
    </li>
    <li>
        Abierto de Australia Femenino (WTA)
    </li>
    <li>
        Roland Garros Femenino (WTA)
    </li>
    <li>
        US Open Femenino (WTA)
    </li>
    <li>
        WTA Finals
    </li>
    <li>
        Madrid Open España (WTA 1000)
    </li>
    <li>
        WTA 1000 de Miami
    </li>
    <li>
        WTA 1000 de Estados Unidos
    </li>
    <li>
        Indian Wells Open ABD (WTA 1000)
    </li>
    <li>
        WTA 1000 de Roma
    </li>
    <li>
        WTA 1000 de Pekín
    </li>
    <li>
        Copa Davis
    </li>
    <li>
        Copa Billie Jean King
    </li>
    <li>
        United Cup
    </li>
    <li>
        Cincinnati Masters ABD (WTA Masters 1000)
    </li>
</ul>
<p>
    <strong>14.4 Hockey sobre Hielo</strong>
</p>
<ul>
    <li>
        Campeonato Mundial Masculino de Hockey sobre Hielo IIHF
    </li>
    <li>
        NHL (Liga Nacional de Hockey)
    </li>
</ul>
<p>
    <strong>14.5 Béisbol</strong>
</p>
<ul>
    <li>
        Major League Baseball (MLB)
    </li>
    <li>
        Béisbol Universitario NCAA
    </li>
</ul>
<p>
    <strong>14.6 Fútbol Americano</strong>
</p>
<ul>
    <li>
        National Football League (NFL)
    </li>
    <li>
        Fútbol Americano Universitario NCAA (NCAAF)
    </li>
</ul>



    </div>

  </div>
</template>

<script>
export default {};
</script>

<style>
.p {
  background-color: #fff;
}
.tabl {
  border: 1px solid #c0c0c0;
  border-collapse: collapse;
  padding: 5px;
  background: white;
  color: black;
  border-radius: 4px !important;
  width: 100%;
}
.tabd {
  border: 1px solid #c0c0c0;
  border-collapse: collapse;
  padding: 10px;
  background: white;
  color: black;
  border-radius: 4px !important;
  width: 100%;
}
.tabl th {
  border: 1px solid #c0c0c0;
  padding: 5px;
  border-radius: 4px !important;
  font-size: 12px !important;
}
.tabl td {
  border: 1px solid #c0c0c0;
  padding: 5px;
  border-radius: 4px !important;
}
</style>
